const toPython_E7 = function (Blockly, runtime) {


    Blockly.Python = new Blockly.Generator("Python");
    Blockly.Python.addReservedWords("False,None,True,and,as,assert,break,class,continue,def,del,elif,else,except,exec,finally,for,from,global,if,import,in,is,lambda,nonlocal,not,or,pass,print,raise,return,try,while,with,yield,NotImplemented,Ellipsis,__debug__,quit,exit,copyright,license,credits,ArithmeticError,AssertionError,AttributeError,BaseException,BlockingIOError,BrokenPipeError,BufferError,BytesWarning,ChildProcessError,ConnectionAbortedError,ConnectionError,ConnectionRefusedError,ConnectionResetError,DeprecationWarning,EOFError,Ellipsis,EnvironmentError,Exception,FileExistsError,FileNotFoundError,FloatingPointError,FutureWarning,GeneratorExit,IOError,ImportError,ImportWarning,IndentationError,IndexError,InterruptedError,IsADirectoryError,KeyError,KeyboardInterrupt,LookupError,MemoryError,ModuleNotFoundError,NameError,NotADirectoryError,NotImplemented,NotImplementedError,OSError,OverflowError,PendingDeprecationWarning,PermissionError,ProcessLookupError,RecursionError,ReferenceError,ResourceWarning,RuntimeError,RuntimeWarning,StandardError,StopAsyncIteration,StopIteration,SyntaxError,SyntaxWarning,SystemError,SystemExit,TabError,TimeoutError,TypeError,UnboundLocalError,UnicodeDecodeError,UnicodeEncodeError,UnicodeError,UnicodeTranslateError,UnicodeWarning,UserWarning,ValueError,Warning,ZeroDivisionError,_,__build_class__,__debug__,__doc__,__import__,__loader__,__name__,__package__,__spec__,abs,all,any,apply,ascii,basestring,bin,bool,buffer,bytearray,bytes,callable,chr,classmethod,cmp,coerce,compile,complex,copyright,credits,delattr,dict,dir,divmod,enumerate,eval,exec,execfile,exit,file,filter,float,format,frozenset,getattr,globals,hasattr,hash,help,hex,id,input,int,intern,isinstance,issubclass,iter,len,license,list,locals,long,map,max,memoryview,min,next,object,oct,open,ord,pow,print,property,quit,range,raw_input,reduce,reload,repr,reversed,round,set,setattr,slice,sorted,staticmethod,str,sum,super,tuple,type,unichr,unicode,vars,xrange,zip");
    Blockly.Python.ORDER_ATOMIC = 0;
    Blockly.Python.ORDER_COLLECTION = 1;
    Blockly.Python.ORDER_STRING_CONVERSION = 1;
    Blockly.Python.ORDER_MEMBER = 2.1;
    Blockly.Python.ORDER_FUNCTION_CALL = 2.2;
    Blockly.Python.ORDER_EXPONENTIATION = 3;
    Blockly.Python.ORDER_UNARY_SIGN = 4;
    Blockly.Python.ORDER_BITWISE_NOT = 4;
    Blockly.Python.ORDER_MULTIPLICATIVE = 5;
    Blockly.Python.ORDER_ADDITIVE = 6;
    Blockly.Python.ORDER_BITWISE_SHIFT = 7;
    Blockly.Python.ORDER_BITWISE_AND = 8;
    Blockly.Python.ORDER_BITWISE_XOR = 9;
    Blockly.Python.ORDER_BITWISE_OR = 10;
    Blockly.Python.ORDER_RELATIONAL = 11;
    Blockly.Python.ORDER_LOGICAL_NOT = 12;
    Blockly.Python.ORDER_LOGICAL_AND = 13;
    Blockly.Python.ORDER_LOGICAL_OR = 14;
    Blockly.Python.ORDER_CONDITIONAL = 15;
    Blockly.Python.ORDER_LAMBDA = 16;
    Blockly.Python.ORDER_NONE = 99;
    Blockly.Python.ORDER_OVERRIDES = [
        [Blockly.Python.ORDER_FUNCTION_CALL, Blockly.Python.ORDER_MEMBER],
        [Blockly.Python.ORDER_FUNCTION_CALL, Blockly.Python.ORDER_FUNCTION_CALL],
        [Blockly.Python.ORDER_MEMBER, Blockly.Python.ORDER_MEMBER],
        [Blockly.Python.ORDER_MEMBER, Blockly.Python.ORDER_FUNCTION_CALL],
        [Blockly.Python.ORDER_LOGICAL_NOT, Blockly.Python.ORDER_LOGICAL_NOT],
        [Blockly.Python.ORDER_LOGICAL_AND, Blockly.Python.ORDER_LOGICAL_AND],
        [Blockly.Python.ORDER_LOGICAL_OR, Blockly.Python.ORDER_LOGICAL_OR],
        [2, 1]
    ];
    Blockly.Variables.allUsedVariabless = function (a) {
        if (a instanceof Blockly.Block) var b = a.getDescendants(!1);
        else if (a instanceof Blockly.Workspace || a instanceof Blockly.WorkspaceSvg) b = a.getAllBlocks();
        else throw new Error("Not Block or Workspace: " + a);
        var c = Blockly.Variables.noVariableText();

        let Monitor = runtime.getMonitorState()

        a = Object.create(null);
        for (var d = 0; d < b.length; d++) {
            var e = b[d].getVarModels();
            if (e)
                for (var f = 0; f < e.length; f++) {
                    var g = e[f];
                    // g.getId() && g.name.toLowerCase() != c && (a[g.name.toLowerCase()] = g.name)
                    if (g.getId() && g.name.toLowerCase() !== c) {
                        if (g.type === "") {
                            if (!a['']) {
                                a[''] = {}
                            }
                            a[''][g.name] = 0
                        } else if (g.type === "list") {
                            if (!a['list']) {
                                a['list'] = {}
                            }
                            Monitor.valueSeq().toList().map(item => {
                                let mode = item.mode
                                let value = item.value
                                if (mode == "list") {
                                    a['list'][g.name] = value

                                }
                            })
                        } else {

                        }
                    }
                }
        }

        // b = [];
        // for (var h in a) b.push(a[h]);
        return a
    };
    Blockly.Python.init = function (a) {
        Blockly.Python.PASS = this.INDENT + "pass\n";
        Blockly.Python.definitions_ = Object.create(null);
        Blockly.Python.functionNames_ = Object.create(null);
        Blockly.Python.jmdstart = Object.create(null); //拿到头部文件作为最后的函数调用
        Blockly.Python.list = Object.create(null);
        Blockly.Python.varibles = new Array();
        Blockly.Python.pidList = new Set(); //pid数据初始化列表
        Blockly.Python.pidThreadFn = Object.create(null); //pid线程函数

        // 线程函数
        Blockly.Python.Thread = Object.create(null)

        Blockly.Python.variableDB_ ? Blockly.Python.variableDB_.reset() : Blockly.Python.variableDB_ = new Blockly.Names(Blockly.Python.RESERVED_WORDS_);
        Blockly.Python.variableDB_.setVariableMap(a.getVariableMap());
        for (var b = [], c = Blockly.Variables.allDeveloperVariables(a), d = 0; d < c.length; d++) b.push(c[d] +
            " = 0");
        // a = Blockly.Variables.allUsedVariables(a);
        a = Blockly.Variables.allUsedVariabless(a)

        for (let i in a) {
            for (let j in a[i]) {
                let varname = ''
                let data = JSON.stringify(a[i][j])
                if (i === "") {
                    varname = 'VAR_' + j
                    b.push(varname + " = 0")
                } else if (i === "list") {
                    varname = 'LIST_' + j
                    b.push(varname + " = " + data)
                } else {
                    b.push(varname + " = 0")
                }
                Blockly.Python.varibles.push(varname)
            }
        }
        // for (d = 0; d < a.length; d++) {
        //     Blockly.Python.varibles.push(a[d])
        //     if (a[d].type == "lists") {
        //         b.push(a[d] + " = []")
        //     } else {
        //         b.push(a[d] + " = 0")
        //     }
        // };

        Blockly.Python.definitions_.variables = b.join("\n")
    };
    Blockly.Python.finish = function (a) {
        var b = [],
            c = [],
            f = [],
            h = [],
            d,
            l = '',
            pidvar = '',
            pidFn = '',
            threads = []
        for (d in Blockly.Python.definitions_) {
            var e = Blockly.Python.definitions_[d];
            e.match(/^(from\s+\S+\s+)?import\s+\S+/) ? b.push(e) : c.push(e)
        }
        //遍历有多少个头部块，就在最后添加对应的函数调用
        for (var g in Blockly.Python.jmdstart) {
            f.push(Blockly.Python.jmdstart[g] + "()")
        }

        for (var thread in Blockly.Python.Thread) {
            threads.push(Blockly.Python.Thread[thread])
        }

        //遍历列表的所有参数
        for (let i in Blockly.Python.list) {
            h.push(i)
            l += i + '=[]\n'
        }

        Blockly.Python.pidList.forEach((item) => {
            pidvar += item + ' = 0\r\n'
            Blockly.Python.varibles.push(item)
        })

        a = Blockly.Python.varibles.length > 0 ? a.replace(/\[GLOBAL]/g, "\r\n  global " + Blockly.Python.varibles.join(',')) : a.replace(/\[GLOBAL]/g, '')
        threads = threads.join("\n\n")
        threads = Blockly.Python.varibles.length > 0 ? threads.replace(/\[GLOBAL]/g, "\r\n  global " + Blockly.Python.varibles.join(',')) : threads.replace(/\[GLOBAL]/g, '')


        Object.keys(Blockly.Python.pidThreadFn).length > 0 ? pidFn += "\r\n" : null
        Object.keys(Blockly.Python.pidThreadFn).map((item) => {
            pidFn += Blockly.Python.pidThreadFn[item] + '\r\n'
        })

        var thrad = f.length > 1 ? "import _thread\r\n" : ""
        var thradEnd = f.length > 1 ? Blockly.Python.mainEnd(f) : f.join("\r\n")

        delete Blockly.Python.definitions_;
        delete Blockly.Python.functionNames_;
        delete Blockly.Python.jmdstart;
        Blockly.Python.variableDB_.reset();
        return thrad + (b.join("\n") + "\n\n" + pidvar + l + pidFn + c.join("\n\n")).replace(/\n\n+/g, "\n\n").replace(/\n*$/, "\n\n") + a + "\n" + threads + "\n" + thradEnd
    };
    Blockly.Python.mainEnd = function (a) {
        let top = "def main():\r\n"
        for (let b in a) {
            top += "  _thread.start_new_thread(" + a[b].replace("()", "") + ",())\r\n"
        }
        top += "\r\nmain()\r\n\r\nwhile 1:\r\n  pass"
        return top
    };
    Blockly.Python.scrubNakedValue = function (a) {
        return a + "\n"
    };
    Blockly.Python.quote_ = function (a) {
        a = a.replace(/\\/g, "\\\\").replace(/\n/g, "\\\n");
        var b = "'"; - 1 !== a.indexOf("'") && (-1 === a.indexOf('"') ? b = '"' : a = a.replace(/'/g, "\\'"));
        return b + a + b
    };
    Blockly.Python.multiline_quote_ = function (a) {
        a = a.replace(/'''/g, "\\'\\'\\'");
        return "'''" + a + "'''"
    };
    Blockly.Python.scrub_ = function (a, b, c) {
        var d = "";
        if (!a.outputConnection || !a.outputConnection.targetConnection) {
            var e = a.getCommentText();
            if (e) {
                e = Blockly.utils.wrap(e, Blockly.Python.COMMENT_WRAP - 3)
                d += Blockly.Python.prefixLines(e + "\n", "# ")
            }
            // e && (e = Blockly.utils.wrap(e, Blockly.Python.COMMENT_WRAP - 3), d += Blockly.Python.prefixLines(e + "\n", "# "));
            for (var f = 0; f < a.inputList.length; f++) a.inputList[f].type === Blockly.INPUT_VALUE && (e = a.inputList[f].connection.targetBlock()) && (e = Blockly.Python.allNestedComments(e)) && (d += Blockly.Python.prefixLines(e, "# "))
        }
        a = a.nextConnection && a.nextConnection.targetBlock();
        c = c ? "" : Blockly.Python.blockToCode(a);
        return d + b + c
    };
    Blockly.Python.getPidGlobal = function (a) {
        let pidGlobal = ""
        if (Blockly.Python.pidList.size > 0) {
            pidGlobal = "global "
            pidGlobal += [...Blockly.Python.pidList].join(',')
        }
        return pidGlobal
    }
    // Blockly.Python.getAdjustedInt = function (a, b, c, d) {
    //     c = c || 0;
    //     a.workspace.options.oneBasedIndex && c--;
    //     var e = a.workspace.options.oneBasedIndex ? "1" : "0";
    //     a = Blockly.Python.valueToCode(a, b, c ? Blockly.Python.ORDER_ADDITIVE : Blockly.Python.ORDER_NONE) || e;
    //     Blockly.isNumber(a) ? (a = parseInt(a, 10) + c, d && (a = -a)) : (a = 0 < c ? "int(" + a + " + " + c + ")" : 0 > c ? "int(" + a + " - " + -c + ")" : "int(" + a + ")", d && (a = "-" + a));
    //     return a
    // };

    Blockly.Python.transformColor = function (color) {
        var colors = color.slice(1)
        var newColors = ''
        for (var j = 0; j < colors.length; j++) {
            if (colors[j] !== '0') {
                newColors = colors.slice(j)
                break;
            } else if (colors == '000000') {
                newColors = '0'
                break;
            }
        }
        var newColor = '';
        for (var i = 0; i < newColors.length; i++) {
            newColor += newColors[i].toLocaleUpperCase()
        }
        return '0x' + newColor

    }
    Blockly.Python.replaceColor = function (color) {
        switch (color) {
            case "0xF800":
                return `"#F80000"`
            case "0x07E0":
                return `"#07E000"`
            case "0x001F":
                return `"#0051FF"`
            case "0xFFE0":
                return `"#FFE000"`
            case "0xF81F":
                return `"#E600FF"`
            case "0x07FF":
                return `"#00E6FF"`
            case "0xFFFF":
                return `"#FFFFFF"`
            case "0x0000":
                return `"#000000"`
            default:
                return `"#000000"`
        }
    }

    Blockly.Python.matrixToString16 = function (matrix) {
        let arr = []
        for (var i = 0; i < matrix.length;) {
            // 字符串翻转
            var length = (matrix.slice(i, i + 8)).length;
            length = length - 1;
            var newstr = ''
            for (var x = length; x >= 0; x--) {
                newstr += (matrix.slice(i, i + 8)).charAt(x);
            }

            arr.push(newstr)
            i += 8
        }
        let value = ''
        for (var j = 0; j < arr.length; j++) {
            let temp = parseInt(arr[j], 2)
            temp = temp.toString(16)
            // 十六进制，不够两位补0
            let zero = '00';
            let tmp = 2 - temp.length;
            value += zero.substr(0, tmp) + temp;

        }
        return value
    }

    Blockly.Python.getTaskName = function (name, index = 1) {
        let fnName = name + index
        if (Blockly.Python.jmdstart[fnName]) {
            return Blockly.Python.getTaskName(name, index + 1)
        }
        return fnName
    }


    //-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------





    Blockly.Python.pass = "    pass\n";

    Blockly.Python.jmd_start = function (a) {
        let task = a.getFieldValue("TASK");
        let passEnd = a.getNextBlock() ? "" : "  pass\n"
        Blockly.Python.jmdstart[a.id] = task;
        Blockly.Python.definitions_.import_random = "import rcu";
        return "def " + task + "():[GLOBAL]\r\n" + passEnd;
    };


    Blockly.Python.E7_event_ultrasonic = function (a) {
        let task = Blockly.Python.getTaskName("taskUltrasonic")
        let port = a.getFieldValue("PORT");
        let status = a.getFieldValue("STATUS");
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);

        // 获取代码
        let code = Blockly.Python.blockToCode(a.getNextBlock()) || "  pass"
        //给代码添加前缀，因为要放在函数内部，所以需要添加两个空格
        code = Blockly.Python.prefixLines(code, "    ")

        Blockly.Python.jmdstart[task] = task;
        Blockly.Python.definitions_.import_random = "import rcu";
        Blockly.Python.Thread[task] = `def ${task}():[GLOBAL]\r\n  while True:\r\n    if(rcu.GetUltrasound(${port}) ${status} ${value}):\r\n${code}`;
    };


    Blockly.Python.E7_event_colorSensor = function (a) {
        let task = Blockly.Python.getTaskName("taskColorSensor")
        let port = a.getFieldValue("PORT");
        let color = a.getFieldValue("COLOR");

        // 获取代码
        let code = Blockly.Python.blockToCode(a.getNextBlock()) || "  pass"
        //给代码添加前缀，因为要放在函数内部，所以需要添加两个空格
        code = Blockly.Python.prefixLines(code, "    ")

        Blockly.Python.jmdstart[task] = task;
        Blockly.Python.definitions_.import_random = "import rcu";
        Blockly.Python.Thread[task] = `def ${task}():[GLOBAL]\r\n  while True:\r\n    if(rcu.GetColorSensorForPort(${port}) == ${color}):\r\n${code}`;
    };


    Blockly.Python.E7_event_touchSensor = function (a) {
        let task = Blockly.Python.getTaskName("taskTouchSensor")
        let port = a.getFieldValue("PORT");
        let status = a.getFieldValue("STATUS");

        // 获取代码
        let code = Blockly.Python.blockToCode(a.getNextBlock()) || "  pass"
        //给代码添加前缀，因为要放在函数内部，所以需要添加两个空格
        code = Blockly.Python.prefixLines(code, "    ")

        Blockly.Python.jmdstart[task] = task;
        Blockly.Python.definitions_.import_random = "import rcu";
        Blockly.Python.Thread[task] = `def ${task}():[GLOBAL]\r\n  while True:\r\n    if(rcu.GetTouchForPort(${port}) == ${status}):\r\n${code}`;
    };


    Blockly.Python.E7_event_voiceSensor = function (a) {
        let task = Blockly.Python.getTaskName("taskVoiceSensor")
        let status = a.getFieldValue("STATUS");
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);

        // 获取代码
        let code = Blockly.Python.blockToCode(a.getNextBlock()) || "  pass"
        //给代码添加前缀，因为要放在函数内部，所以需要添加两个空格
        code = Blockly.Python.prefixLines(code, "    ")

        Blockly.Python.jmdstart[task] = task;
        Blockly.Python.definitions_.import_random = "import rcu";
        Blockly.Python.Thread[task] = `def ${task}():[GLOBAL]\r\n  while True:\r\n    if(rcu.getMaiVoice() ${status} ${value}):\r\n${code}`;
    };




    Blockly.Python.jmd_getLeftButton = function (a) {
        return ["rcu.GetLeftButton()", 1];
    };
    Blockly.Python.jmd_getRightButton = function (a) {
        return ["rcu.GetRightButton()", 1];
    };
    Blockly.Python.jmd_getInMic = function (a) {
        return ["rcu.GetInMic()", 1];
    };
    Blockly.Python.jmd_getBatteryVoltage = function (a) {
        return ["rcu.GetInVotage()", 1];
    };
    Blockly.Python.jmd_getControlTime = function (a) {
        return ["rcu.GetSysTime()", 1];
    };
    Blockly.Python.jmd_setControlTimeZero = function (a) {
        return "  rcu.SetSysTime()\r\n";
    };
    Blockly.Python.jmd_setBeep = function (a) {
        let state = a.getFieldValue("STATE");
        return "  rcu.SetInBeep(" + state + ")\r\n";
    };
    Blockly.Python.jmd_setInSound = function (a) {
        let frequency = a.getFieldValue("FREQUENCY");
        let time = Blockly.Python.valueToCode(a, "TIME", 2);
        return "  rcu.SetInSound(" + frequency + ",(" + time + " * 1000))\r\n";
    };
    Blockly.Python.jmd_getData = function (a) {
        return ["rcu.GetData(" + Blockly.Python.valueToCode(a, "ADDRESS", 2) + ")", 1, ];
    };
    Blockly.Python.jmd_setData = function (a) {
        let address = Blockly.Python.valueToCode(a, "ADDRESS", 2);
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);
        return "  rcu.SetData(" + address + "," + value + ")\r\n";
    };

    Blockly.Python.E7_jmd_getData = function (a) {
        return ["rcu.GetData(" + Blockly.Python.valueToCode(a, "ADDRESS", 2) + ")", 1, ];
    };
    Blockly.Python.E7_jmd_setData = function (a) {
        let address = Blockly.Python.valueToCode(a, "ADDRESS", 2);
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);
        return "  rcu.SetData(" + address + "," + value + ")\r\n";
    };
    Blockly.Python.E7_jmd_setSaveStudyDataToFile = function (a, b, c) {
        let data = Blockly.Python.valueToCode(a, "DATA", 2);
        let name = Blockly.Python.valueToCode(a, "NAME", 2);
        return "  rcu.setSaveStudyDataToFile(" + data + "," + name + ")\r\n";
    };
    Blockly.Python.E7_jmd_setDeleteStudyFile = function (a, b, c) {
        let name = Blockly.Python.valueToCode(a, "NAME", 2);
        return "  rcu.setDeleteStudyFile(" + name + ")\r\n";
    };
    Blockly.Python.E7_jmd_setShowFileData = function (a, b, c) {
        let name = Blockly.Python.valueToCode(a, "NAME", 2);
        return "  rcu.setShowFileData(" + name + ")\r\n";
    };
    Blockly.Python.E7_jmd_savePic = function (a, b, c) {
        let name = Blockly.Python.valueToCode(a, "NAME", 2);
        return "  rcu.savePic(" + name + ")\r\n";
    };
    Blockly.Python.E7_setEditView = function (a, b, c) {
        let left_message = Blockly.Python.valueToCode(a, "LEFTMARGIN", 2);
        let right_message = Blockly.Python.valueToCode(a, "RIGHTMARGIN", 2);
        let message = Blockly.Python.valueToCode(a, "MESSAGE", 2);
        return `  rcu.setEditView(${left_message},${right_message},${message})\r\n`;
    };
    Blockly.Python.E7_getEditViewData = function (a, b, c) {
        return [`rcu.getEditViewData()`, 1];
    };
    Blockly.Python.E7_GetHRCUName = function (a, b, c) {
        return [`rcu.GetHRCUName()`, 1];
    };
    Blockly.Python.E7_GetCcrrentDate = function (a, b, c) {
        return [`rcu.GetCcrrentDate()`, 1];
    };
    Blockly.Python.E7_SetSaveStrToFile = function (a, b, c) {
        let string = Blockly.Python.valueToCode(a, "STRING", 2);
        let filename = Blockly.Python.valueToCode(a, "FILENAME", 2);
        return `  rcu.SetSaveStrToFile(${string}, ${filename})\r\n`;
    };
    Blockly.Python.E7_GetStrForFile = function (a, b, c) {
        let filename = Blockly.Python.valueToCode(a, "FILENAME", 2);
        let linenum = Blockly.Python.valueToCode(a, "LINENUM", 2);
        return [`rcu.GetStrForFile(${filename}, ${linenum})`, 1];
    };


    Blockly.Python.jmd_getMaiVoice = function (a, b, c) {
        return [`rcu.getMaiVoice()`, 1];
    };
    Blockly.Python.jmd_getChangeValue = function (a, b, c) {
        return [`rcu.getChangeValue()`, 1];
    };
    Blockly.Python.jmd_getRcuTime = function (a, b, c) {
        return [`rcu.getRcuTime()`, 1];
    };
    Blockly.Python.jmd_setRcuTimeTo0 = function (a, b, c) {
        return `  rcu.setRcuTimeTo0()\r\n`;
    };




    //马达

    Blockly.Python.motor_setMotor = function (a, b, c) {
        let motorport = a.getFieldValue("MOTORPORT");
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);
        return "  rcu.SetMotor(" + motorport + "," + value + ")\r\n";
    };
    Blockly.Python.motor_getMotorCode = function (a, b, c) {
        let motorport = a.getFieldValue("MOTORPORT");
        return ["rcu.GetMotorCode(" + motorport + ")", 1];
    };
    Blockly.Python.E7_motor_getMotorCode = function (a, b, c) {
        let motorport = a.getFieldValue("MOTORPORT");
        return ["rcu.GetMotorCode(" + motorport + ")", 1];
    };
    Blockly.Python.motor_setMotorCode = function (a, b, c) {
        let motorport = a.getFieldValue("MOTORPORT");
        return "  rcu.SetMotorCode(" + motorport + ")\r\n";
    };
    Blockly.Python.E7_motor_setMotorCode = function (a, b, c) {
        let motorport = a.getFieldValue("MOTORPORT");
        return "  rcu.SetMotorCode(" + motorport + ")\r\n";
    };
    Blockly.Python.E7_motor_getMotorAngle = function (a, b, c) {
        let motorport = a.getFieldValue("MOTORPORT");
        return ["rcu.getMotorAngle(" + motorport + ")", 1]
    };
    Blockly.Python.E7_motor_getMotorV = function (a, b, c) {
        let motorport = a.getFieldValue("MOTORPORT");
        return ["rcu.getMotorV(" + motorport + ")", 1]
    };


    Blockly.Python.motor_setServoMotor = function (a, b, c) {
        let motorport = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  rcu.SetMotorServo(" + motorport + "," + speed + "," + angle + ")\r\n";
    };
    Blockly.Python.motor_waitServomotor = function (a, b, c) {
        let motorport = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  rcu.SetWaitForAngle(" + motorport + "," + speed + "," + angle + ")\r\n";
    };
    Blockly.Python.motor_setLinearSpeed = function (a, b, c) {
        let motorport1 = a.getFieldValue("PORT1");
        let motorport2 = a.getFieldValue("PORT2");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let pulse = Blockly.Python.valueToCode(a, "PULSE", 2);
        return "  rcu.SetMotorStraightAngle(" + motorport1 + "," + motorport2 + "," + speed + "," + pulse + ")\r\n";
    };
    Blockly.Python.motor_setTurnSpeed = function (a, b, c) {
        let motorport1 = a.getFieldValue("PORT1");
        let motorport2 = a.getFieldValue("PORT2");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let pulse = Blockly.Python.valueToCode(a, "PULSE", 2);
        return "  rcu.SetCarTurn(" + motorport1 + "," + motorport2 + "," + speed + "," + pulse + ")\r\n";
    };
    Blockly.Python.motor_setMotorPower = function (a, b, c) {
        let motorone = Blockly.Python.valueToCode(a, "MOTORONE", 2);
        let motortwo = Blockly.Python.valueToCode(a, "MOTORTWO", 2);
        let motorthree = Blockly.Python.valueToCode(a, "MOTORTHREE", 2);
        let motorfour = Blockly.Python.valueToCode(a, "MOTORFOUR", 2);
        return "  rcu.SetMotorPower(" + motorone + "," + motortwo + "," + motorthree + "," + motorfour + ")\r\n";
    };
    Blockly.Python.motor_setMotorStraight = function (a, b, c) {
        let motorport1 = a.getFieldValue("MOTORPORTONE");
        let motorport2 = a.getFieldValue("MOTORPORTTWO");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        return "  rcu.SetMotorStraight(" + motorport1 + "," + motorport2 + "," + speed + ")\r\n";
    };
    Blockly.Python.motor_setMotorStraightTurn = function (a, b, c) {
        let motorport1 = a.getFieldValue("MOTORPORTONE");
        let motorport2 = a.getFieldValue("MOTORPORTTWO");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  rcu.SetMotorStraightTurn(" + motorport1 + "," + motorport2 + "," + speed + "," + angle + ")\r\n";
    };
    Blockly.Python.motor_setServo = function (a, b, c) {
        let prop = a.getFieldValue("PROP");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  rcu.SetServo(" + prop + "," + angle + ")\r\n";
    };
    Blockly.Python.motor_setServoTime = function (a, b, c) {
        let prop = a.getFieldValue("PROP");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        let time = Blockly.Python.valueToCode(a, "TIME", 2);
        return "  rcu.SetServoTime(" + prop + "," + angle + "," + time + ")\r\n";
    };
    Blockly.Python.motor_setServo_E6 = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  rcu.SetServo(" + prop + "," + angle + ")\r\n";
    };
    Blockly.Python.motor_setServo_OS = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  rcu.SetServo(" + prop + "," + angle + ")\r\n";
    };
    Blockly.Python.motor_setServoTime_E6 = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        let time = Blockly.Python.valueToCode(a, "TIME", 2);
        return "  rcu.SetServoTime(" + prop + "," + angle + "," + time + ")\r\n";
    };
    Blockly.Python.motor_setOneServo = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let channel = Blockly.Python.valueToCode(a, "CHANNEL", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        let time = Blockly.Python.valueToCode(a, "TIME", 2);
        return "  rcu.SetOneServo(" + prop + "," + channel + "," + angle + "," + time + ")\r\n";
    };

    Blockly.Python.motor_setSteeringRelease = function (a, b, c) {
        let port = a.getFieldValue("PORT");
        return `  rcu.setSteeringRelease(${port})\r\n`;
    };

    Blockly.Python.motor_stopMotor = function (a, b, c) {
        let port = a.getFieldValue("PORT");
        return `  rcu.stopMotor(${port})\r\n`;
    };
    Blockly.Python.motor_setMotorVByOther = function (a, b, c) {
        let port = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 16);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let model = a.getFieldValue("MODEL");
        return `  rcu.setMotorVByOther(${port},${speed},${angle},"${model}")\r\n`;
    };
    Blockly.Python.motor_waitMotorTo = function (a, b, c) {
        let port = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 16);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let model = a.getFieldValue("MODEL");
        return `  rcu.waitMotorTo(${port},${speed},${angle},"${model}")\r\n`;
    };

    Blockly.Python.motor_setSteeringAngle = function (a, b, c) {
        let port = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        let time = Blockly.Python.valueToCode(a, "TIME", 2);
        let direction = a.getFieldValue("DIRECTION");
        return `  rcu.setSteeringAngle(${port},${angle},${time},"${direction}")\r\n`;
    };
    Blockly.Python.motor_setMotor_E7 = function (a, b, c) {
        let motorport = a.getFieldValue("MOTORPORT");
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);
        return "  rcu.SetMotor(" + motorport + "," + value + ")\r\n";
    };
    Blockly.Python.motor_setMotorPowerIs = function (a, b, c) {
        let port = a.getFieldValue("PORT");
        let status = a.getFieldValue("STATUS");
        return `  rcu.setMotorPowerIs(${port},${status})\r\n`;
    };


    //M6 RCU 马达特有的积木块

    Blockly.Python.motor_setServoMotor48 = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  rcu.SetMotorServo48(" + prop + "," + speed + "," + angle + ")\r\n";
    };

    Blockly.Python.motor_waitServomotor48 = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  rcu.SetWaitForAngle48(" + prop + "," + speed + "," + angle + ")\r\n";
    };

    Blockly.Python.motor_setServoMotor128 = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  rcu.SetMotorServo128(" + prop + "," + speed + "," + angle + ")\r\n";
    };

    Blockly.Python.motor_waitservomotor128 = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  rcu.SetWaitForAngle128(" + prop + "," + speed + "," + angle + ")\r\n";
    };
    Blockly.Python.motor_setServo_M6 = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  rcu.SetServo(" + prop + "," + angle + ")\r\n";
    };
    Blockly.Python.motor_setServoTime_M6 = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        let time = Blockly.Python.valueToCode(a, "TIME", 2);
        return "  rcu.SetServoTime(" + prop + "," + angle + "," + time + ")\r\n";
    };


    //控制
    Blockly.Python.math_positive_number = function (a) {
        let num = a.getFieldValue('NUM');
        return [num, 1];
    };
    Blockly.Python.control_wait = function (a) {
        let time = Blockly.Python.valueToCode(a, "DURATION", 2);
        return "  rcu.SetWaitForTime(" + time + ")\r\n";
    };
    Blockly.Python.control_repeat = function (block) {
        let time = Blockly.Python.valueToCode(block, "TIMES", 2);
        let branch = Blockly.Python.statementToCode(block, "SUBSTACK");
        branch = branch ? (Blockly.Python.addLoopTrap(branch, branch) || Blockly.Python.pass) : Blockly.Python.pass;
        return "  for count in range(" + time + "):\r\n" + branch;
    };
    Blockly.Python.control_forever = function (block) {
        let branch = Blockly.Python.statementToCode(block, "SUBSTACK");
        branch = Blockly.Python.addLoopTrap(branch, branch) || Blockly.Python.pass;
        return "  while True:\r\n" + branch;
    };
    Blockly.Python.control_if = function (block) {
        let bool = Blockly.Python.valueToCode(block, "CONDITION", 2);
        if (bool === "") {
            bool = "FALSE";
        }
        let branch = Blockly.Python.statementToCode(block, "SUBSTACK");
        branch = Blockly.Python.addLoopTrap(branch, branch) || Blockly.Python.pass;
        return "  if " + bool + ":\r\n" + branch;
    };
    Blockly.Python.control_if_else = function (block) {
        let bool = Blockly.Python.valueToCode(block, "CONDITION", 2);
        if (bool === "") {
            bool = "FALSE";
        }
        let branch1 = Blockly.Python.statementToCode(block, "SUBSTACK", 2);
        branch1 = Blockly.Python.addLoopTrap(branch1, branch1) || Blockly.Python.pass;
        let branch2 = Blockly.Python.statementToCode(block, "SUBSTACK2");
        branch2 = Blockly.Python.addLoopTrap(branch2, branch2) || Blockly.Python.pass;
        return "  if " + bool + ":\r\n" + branch1 + "  else:\r\n" + branch2;
    };
    Blockly.Python.control_wait_until = function (block) {
        let bool = Blockly.Python.valueToCode(block, "CONDITION", 2);
        console.log(bool)
        return "  while not(" + bool + "):\r\n    pass\r\n";
    };
    Blockly.Python.control_repeat_until = function (block) {
        let bool = Blockly.Python.valueToCode(block, "CONDITION", 2);
        console.log(bool)
        let branch = Blockly.Python.statementToCode(block, "SUBSTACK");
        branch = Blockly.Python.addLoopTrap(branch, branch) || Blockly.Python.pass;
        return "  while not(" + bool + "):\r\n" + branch;
    };

    Blockly.Python.control_stopPy = function (block) {
        let cmd = block.getFieldValue("CMD");
        return `  rcu.stopPy("${cmd}")\r\n`;
    };

    //传感器

    Blockly.Python.sensor_getTouch = function (a) {
        let prop = a.getFieldValue("SENSORPORT");
        return ["rcu.GetTouch(" + prop + ")", 1];
    };
    Blockly.Python.E7_sensor_getTouch = function (a) {
        let prop = a.getFieldValue("SENSORPORT");
        let status = a.getFieldValue("STATUS");
        return [`rcu.GetTouch(${prop},${status})`, 1];
    };
    Blockly.Python.sensor_colorDetection = function (a) {
        let prop = a.getFieldValue("COLORPORT");
        return ["rcu.GetColorSensor(" + prop + ")", 1];
    };
    Blockly.Python.E7_sensor_colorDetection = function (a) {
        let prop = a.getFieldValue("COLORPORT");
        let mode = a.getFieldValue("COLORMODE");
        return [`rcu.GetColorSensor(${prop}, "${mode}")`, 1];
    };
    Blockly.Python.sensor_getUltrasonic = function (a) {
        let prop = a.getFieldValue("ULTRASONICPORT");
        return ["rcu.GetUltrasound(" + prop + ")", 1];
    };
    Blockly.Python.E7_sensor_getUltrasonic = function (a) {
        let prop = a.getFieldValue("ULTRASONICPORT");
        return ["rcu.GetUltrasound(" + prop + ")", 1];
    };
    Blockly.Python.sensor_getLightSensor = function (a) {
        let prop = a.getFieldValue("SENSORPORT");
        return ["rcu.GetLightSensor(" + prop + ")", 1];
    };
    Blockly.Python.E7_sensor_getLightSensor = function (a) {
        let prop = a.getFieldValue("SENSORPORT");
        let mode = a.getFieldValue("MODE");
        return [`rcu.GetLightSensor(${prop}, ${mode})`, 1];
    };
    Blockly.Python.sensor_getLightSensorDigital = function (a) {
        let prop = a.getFieldValue("SENSORPORT");
        return ["rcu.GetLightSensorData(" + prop + ")", 1];
    };
    Blockly.Python.sensor_setLightSensor = function (a) {
        let prop = a.getFieldValue("SENSORPORT");
        let state = a.getFieldValue("STATE");
        return "  rcu.SetLightSensorLed(" + prop + "," + state + ")\r\n";
    };
    Blockly.Python.sensor_setColorLamp = function (a) {
        let prop = a.getFieldValue("SENSORPORT");
        let color = a.getFieldValue("COLOR");
        return "  rcu.Set3CLed(" + prop + "," + color + ")\r\n";
    };
    Blockly.Python.E7_sensor_setColorLamp = function (a) {
        let prop = a.getFieldValue("SENSORPORT");
        let color = a.getFieldValue("COLOR");
        return "  rcu.Set3CLed(" + prop + "," + color + ")\r\n";
    };
    Blockly.Python.sensor_getgesture = function (a) {
        let prop = a.getFieldValue("PORT");
        return ["rcu.GetGesture(" + prop + ")", 1];
    };
    Blockly.Python.sensor_getWifiCamRockCtrlNew = function (a) {
        let rockctrl = a.getFieldValue("ROCKCTRL");
        return ["rcu.GetWifiCamRockCtrlNew(" + rockctrl + ")", 1];
    };
    Blockly.Python.sensor_getWifiPictureData = function (a) {
        let rockctrl = a.getFieldValue("PICTURE");
        return ["rcu.GetWifiPictureData(" + rockctrl + ")", 1];
    };
    Blockly.Python.sensor_getCamRecogData = function (a) {
        let data = Blockly.Python.valueToCode(a, "DATA", 2);
        return ["rcu.GetCamRecog(" + data + ")", 1];
    };
    Blockly.Python.sensor_getWifiCamPictureResult = function (a) {
        let camdata = a.getFieldValue("CAMDATA");
        return ["rcu.GetWifiCamPictureResult(" + camdata + ")", 1];
    };
    Blockly.Python.sensor_getWifiCamPictureSize = function (a) {
        let size = a.getFieldValue("SIZE");
        return ["rcu.GetWifiCamPictureSize(" + size + ")", 1];
    };
    Blockly.Python.sensor_getWifiCamPictureSite = function (a) {
        let site = a.getFieldValue("SITE");
        return ["rcu.GetWifiCamPictureSite(" + site + ")", 1];
    };
    Blockly.Python.sensor_setLizard = function (a) {
        let color = a.getFieldValue("COLOR");
        return "  rcu.SetLizard(" + color + ")\r\n";
    };
    Blockly.Python.sensor_getRFID = function (a) {
        let port = a.getFieldValue("SENSORPORT");
        return ["rcu.GetRFID522(" + port + ")", 1];
    };
    Blockly.Python.sensor_ReadRFIDData = function (a) {
        let port = a.getFieldValue("SENSORPORT");
        return ["rcu.ReadRFID522(" + port + ")", 1];
    };

    Blockly.Python.sensor_WriteRFIDData = function (a) {
        let port = a.getFieldValue("SENSORPORT");
        let data = Blockly.Python.valueToCode(a, "DATA", 2)
        return "  rcu.WriteRFID522(" + port + "," + data + ")\r\n";
    };

    // M6 RCU 传感器特有的积木块

    Blockly.Python.sensor_getRFID2 = function (a) {
        let port = a.getFieldValue("SENSORPORT");
        return ["rcu.GetRFID522(" + port + ")", 1];
    };
    Blockly.Python.sensor_ReadRFIDData2 = function (a) {
        let port = a.getFieldValue("SENSORPORT");
        return ["rcu.ReadRFID522(" + port + ")", 1];
    };
    Blockly.Python.sensor_WriteRFIDData2 = function (a) {
        let port = a.getFieldValue("SENSORPORT");
        let data = Blockly.Python.valueToCode(a, "DATA", 2)
        return "  rcu.WriteRFID522(" + port + "," + data + ")\r\n";
    };



    Blockly.Python.sensor_getColorRgb = function (a, b, c) {
        let port = a.getFieldValue("SENSORPORT");
        let color = a.getFieldValue("COLOR");
        return [`rcu.getColorRgb(${port},"${color}")`, 1];
    };
    Blockly.Python.sensor_isColor = function (a, b, c) {
        let port = a.getFieldValue("SENSORPORT");
        let color = a.getFieldValue("COLOR");
        return [`rcu.isColor(${port},${color})`, 1];
    };
    Blockly.Python.sensor_waitNewColor = function (a, b, c) {
        let port = a.getFieldValue("PORT");
        return `  rcu.waitNewColor(${port})\r\n`;
    };
    Blockly.Python.sensor_waitThisColor = function (a, b, c) {
        let port = a.getFieldValue("PORT");
        let color = a.getFieldValue("COLOR");
        return `  rcu.waitThisColor(${port},${color})\r\n`;
    };
    Blockly.Python.E7_sensor_setLightByRGB = function (a, b, c) {
        let port = a.getFieldValue("PORT");
        let Rvalue = Blockly.Python.valueToCode(a, "R", 16);
        let Gvalue = Blockly.Python.valueToCode(a, "G", 16);
        let Bvalue = Blockly.Python.valueToCode(a, "B", 16);
        return `  rcu.setLightByRGB(${port},${Rvalue},${Gvalue},${Bvalue})\r\n`;
    };
    Blockly.Python.sensor_isUltra = function (a, b, c) {
        let port = a.getFieldValue("PORT");
        let status = a.getFieldValue("STATUS");
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);
        return [`rcu.isUltra(${port},"${status}",${value})`, 1];
    };
    Blockly.Python.sensor_isElectedData = function (a, b, c) {
        let port = a.getFieldValue("PORT");
        let status = a.getFieldValue("STATUS");
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);
        return [`rcu.isElectedData(${port},"${status}",${value})`, 1];
    };

    Blockly.Python.sensor_setElcLightIfData = function (a) {
        let port = a.getFieldValue("PORT");
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);
        return `  rcu.setElcLightIfData(${port},${value})\r\n`;
    };

    Blockly.Python.E7_getPressureData = function (a) {
        let port = a.getFieldValue("PORT");
        return [`rcu.getPressureData(${port})`, 1]
    };
    Blockly.Python.E7_getVoiceData = function (a) {
        let port = a.getFieldValue("PORT");
        return [`rcu.getVoiceSensorData(${port})`, 1]
    };
    Blockly.Python.E7_getTSDData = function (a) {
        let port = a.getFieldValue("PORT");
        return [`rcu.getTSDData(${port})`, 1]
    };
    Blockly.Python.E7_getWDData = function (a) {
        let port = a.getFieldValue("PORT");
        return [`rcu.getWDData(${port})`, 1]
    };
    Blockly.Python.E7_getSDData = function (a) {
        let port = a.getFieldValue("PORT");
        return [`rcu.getSDData(${port})`, 1]
    };
    Blockly.Python.E7_getYDData = function (a) {
        let port = a.getFieldValue("PORT");
        return [`rcu.getYDData(${port})`, 1]
    };
    Blockly.Python.E7_getAirQualityData = function (a) {
        let port = a.getFieldValue("PORT");
        return [`rcu.getAirQualityData(${port})`, 1]
    };
    Blockly.Python.E7_getRFIDNum = function (a) {
        let port = a.getFieldValue("PORT");
        return [`rcu.getRFIDNum(${port})`, 1]
    };
    Blockly.Python.E7_getRFIDData = function (a) {
        let port = a.getFieldValue("PORT");
        return [`rcu.getRFIDData(${port})`, 1]
    };
    Blockly.Python.E7_setRFIDData = function (a) {
        let port = a.getFieldValue("PORT");
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);
        return `  rcu.setRFIDData(${port},${value})\r\n`;
    };

    Blockly.Python.E7_getAttitudeData = function (a) {
        let model = a.getFieldValue("MODEL");
        return [`rcu.getAttitudeData("${model}")`, 1]
    };

    Blockly.Python.E7_getAccData = function (a) {
        let model = a.getFieldValue("MODEL");
        return [`rcu.getAccData("${model}")`, 1]
    };
    Blockly.Python.E7_getMagneticData = function (a) {
        let model = a.getFieldValue("MODEL");
        return [`rcu.getMagneticData("${model}")`, 1]
    };
    Blockly.Python.E7_getGyroscopeData = function (a) {
        let model = a.getFieldValue("MODEL");
        return [`rcu.getGyroscopeData("${model}")`, 1]
    };
    Blockly.Python.E7_getTempAndHumData = function (a) {
        let port = a.getFieldValue("PORT");
        let mode = a.getFieldValue("MODE");
        return [`rcu.getTempAndHumData(${port}, ${mode})`, 1]
    };



    Blockly.Python.E7_setAttitudeModel = function (a) {
        let model = a.getFieldValue("MODEL");
        return `  rcu.setAttitudeModel("${model}")\r\n`;
    };
    Blockly.Python.E7_getEyeData = function (a) {
        let port = a.getFieldValue("PORT");
        return [`rcu.getEyeData(${port})`, 1]
    };

    Blockly.Python.E7_getEyeRedData = function (a) {
        let port = a.getFieldValue("PORT");
        return [`rcu.getEyeRedData(${port})`, 1]
    };
    Blockly.Python.E7_setEyeRedData = function (a) {
        let port = a.getFieldValue("PORT");
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);
        return `  rcu.setEyeRedData(${port},${value})\r\n`;
    };
    Blockly.Python.E7_setEyeModel = function (a) {
        let port = a.getFieldValue("PORT");
        let model = a.getFieldValue("MODEL");
        let color1 = Blockly.Python.valueToCode(a, "COLOR1", 16);
        return `  rcu.setEyeModel(${port},"${model}","${color1}")\r\n`;
    };
    Blockly.Python.E7_setEyeColor = function (a) {
        let port = a.getFieldValue("PORT");
        let color1 = Blockly.Python.valueToCode(a, "COLOR1", 16);
        let color2 = Blockly.Python.valueToCode(a, "COLOR2", 16);
        let color3 = Blockly.Python.valueToCode(a, "COLOR3", 16);
        let color4 = Blockly.Python.valueToCode(a, "COLOR4", 16);
        let color5 = Blockly.Python.valueToCode(a, "COLOR5", 16);
        let color6 = Blockly.Python.valueToCode(a, "COLOR6", 16);
        let color7 = Blockly.Python.valueToCode(a, "COLOR7", 16);
        let color8 = Blockly.Python.valueToCode(a, "COLOR8", 16);
        return `  rcu.setEyeColor(${port},"${color1}","${color2}","${color3}","${color4}","${color5}","${color6}","${color7}","${color8}")\r\n`;
    };





    //AI

    Blockly.Python.sensor_setAICamData = function (a) {
        let aimode = a.getFieldValue("AIMODE");
        let aimode2 = a.getFieldValue("AIMODE2") ? a.getFieldValue("AIMODE2") : 0;
        return "  rcu.SetWaitForAICamData(" + aimode + "," + aimode2 + ")\r\n";
    };
    Blockly.Python.sensor_getAICamData = function (a) {
        let data = a.getFieldValue("DATA");
        return ["rcu.GetAICamData(" + data + ")", 1];
    };
    Blockly.Python.sensor_setWaitForAICamData = function (a) {
        let aimode = a.getFieldValue("AIMODE");
        let aimode2 = a.getFieldValue("AIMODE2") ? a.getFieldValue("AIMODE2") : 0;
        return "  rcu.SetWaitForAICamData(" + aimode + "," + aimode2 + ")\r\n";
    };
    Blockly.Python.sensor_getAICamDataColorDetect = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataQR = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataBall = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataRoad = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataFaceDetect = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataImage = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataImageLearning = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataGesture = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataApriltag = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataTraffic = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataColorLearning = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataFaceLearning = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamVoice = function (a) {
        let order = a.getFieldValue("ORDER");
        return ["rcu.GetAICamVoice(" + order + ")", 1];
    };
    Blockly.Python.sensor_getAIBrainData = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataForest = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataLeftWidth = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataRightWidth = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };

    Blockly.Python.AI_getZxing = function (a) {
        return ["rcu.getZxing()", 1];
    }
    Blockly.Python.AI_getWeather = function (a) {
        let city = Blockly.Python.valueToCode(a, "city", 16);
        let type = a.getFieldValue('type')
        return [`rcu.getWeather(${city},"${type}")`, 1]
    }
    Blockly.Python.AI_getPostAngel = function (a) {
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);
        return [`rcu.getPostAngel(${value})`, 1]
    }

    Blockly.Python.AI_getPost = function (a) {
        let fnName = a.getFieldValue("FNNAME");
        let POST = a.getFieldValue("POST");

        return [`rcu.${fnName}${POST}()`, 1]
    }
    Blockly.Python.AI_getResult = function (a) {
        let fnName = a.getFieldValue("FNNAME");

        return [`rcu.${fnName}()`, 1]
    }
    Blockly.Python.AI_startCamera = function (a) {
        let start = a.getFieldValue("START");
        let fnName = a.getFieldValue("FNNAME");

        return `  rcu.startCamera("${start}","${fnName}")\r\n`;
    }

    Blockly.Python.AI_getFaceResult = function (a) {
        return [`rcu.getFaceResult()`, 1]
    }
    Blockly.Python.AI_isFaceResult = function (a) {
        let data = Blockly.Python.valueToCode(a, "DATA", 16);

        return [`rcu.isFaceResult(${data})`, 1]
    }

    Blockly.Python.AI_getMFColor = function (a) {
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);

        return [`rcu.getMFColor(${value})`, 1]
    }
    Blockly.Python.AI_setStartMF = function (a) {
        let VALUE = a.getFieldValue("VALUE");

        return `  rcu.setStartMF("${VALUE}")\r\n`
    }

    Blockly.Python.AI_isFingerResult = function (a) {
        let FINGER = a.getFieldValue("FINGER");

        return [`rcu.isFingerResult("${FINGER}")`, 1]
    }
    Blockly.Python.AI_isTraficResult = function (a) {
        let TRAFIC = a.getFieldValue("TRAFIC");

        return [`rcu.isTraficResult("${TRAFIC}")`, 1]
    }

    Blockly.Python.AI_getVoiceData = function (a) {
        return [`rcu.getVoiceData()`, 1]
    }
    Blockly.Python.AI_isSimplePoseBy = function (a) {
        let result = a.getFieldValue("RESULT");
        return [`rcu.isSimplePoseBy("${result}")`, 1]
    }
    Blockly.Python.AI_getSimplePoseList = function (a) {
        let part = a.getFieldValue("PART");
        let coordinate = a.getFieldValue("COORDINATE");
        return [`rcu.getSimplePoseList("${part}","${coordinate}")`, 1]
    }
    Blockly.Python.AI_getBlackLineData = function (a) {
        return [`rcu.getBlackLineData()`, 1]
    }
    Blockly.Python.AI_GetRoadAngle = function (a) {
        return [`rcu.GetRoadAngle()`, 1]
    }
    Blockly.Python.AI_getPoseData = function (a) {
        let model = a.getFieldValue("MODEL");
        return [`rcu.getPoseData("${model}")`, 1]
    }


    Blockly.Python.AI_setFaceRegister = function (a) {
        let name = Blockly.Python.valueToCode(a, "NAME", 16);
        return `  rcu.setFaceRegister(${name})\r\n`
    }

    Blockly.Python.AI_getAiData = function (a) {
        let data = a.getFieldValue("DATA");
        return [`rcu.getAiData("${data}")`, 1]
    }
    Blockly.Python.E7_setTTS = function (a) {
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);
        return "  rcu.setTTSSpeack(" + value + ")\r\n";
    };
    Blockly.Python.AI_isAiData = function (a) {
        let reslut = Blockly.Python.valueToCode(a, "RESULT", 16);
        return [`rcu.isAiData(${reslut})`, 1]
    }
    Blockly.Python.AI_getLeft = function (a) {
        return [`rcu.getLeft()`, 1]
    }
    Blockly.Python.AI_getRight = function (a) {
        return [`rcu.getRight()`, 1]
    }
    Blockly.Python.AI_getShipSpeed = function (a) {
        return [`rcu.getShipSpeed()`, 1]
    }
    Blockly.Python.AI_isShipForward = function (a) {
        return [`rcu.isShipForward()`, 1]
    }
    Blockly.Python.AI_isShipBack = function (a) {
        return [`rcu.isShipBack()`, 1]
    }

    Blockly.Python.AI_setAiResult = function (a) {
        return `  rcu.reSetAiResult()\r\n`
    }

    Blockly.Python.AI_isMfConnect = function (a) {
        return [`rcu.isMfConnect()`, 1]
    }
    Blockly.Python.AI_runNext = function (a) {
        return [`rcu.runNext()`, 1]
    }

    Blockly.Python.AI_getForecastTrue = function (a) {
        let arg1 = Blockly.Python.valueToCode(a, "ARG1", 2);
        let arg2 = Blockly.Python.valueToCode(a, "ARG2", 2);
        let arg3 = Blockly.Python.valueToCode(a, "ARG3", 2);
        let arg4 = Blockly.Python.valueToCode(a, "ARG4", 2);
        return [`rcu.getForecastTrue(${arg1},${arg2},${arg3},${arg4})`, 1]
    }

    Blockly.Python.AI_getForecastType = function (a) {
        let arg1 = Blockly.Python.valueToCode(a, "ARG1", 2);
        let arg2 = Blockly.Python.valueToCode(a, "ARG2", 2);
        let arg3 = Blockly.Python.valueToCode(a, "ARG3", 2);
        let arg4 = Blockly.Python.valueToCode(a, "ARG4", 2);
        return [`rcu.getForecastType(${arg1},${arg2},${arg3},${arg4})`, 1]
    }
    Blockly.Python.AI_startMFColor = function (a) {
        let num = a.getFieldValue("NUM") || 0
        return [`rcu.startMFColor(${num})`, 1]
    }
    Blockly.Python.AI_getRunSpeed = function (a) {
        return [`rcu.getRunSpeed()`, 1]
    }

    Blockly.Python.AI_startBDApi = function (a) {
        let status = a.getFieldValue("STATUS");
        return `  rcu.startBDApi("${status}")\r\n`
    }
    Blockly.Python.AI_getTextRecognizeResult = function (a) {
        return [`rcu.getTextRecognizeResult()`, 1]
    }
    Blockly.Python.AI_setTextRecognize = function (a) {
        return `  rcu.setTextRecognize()\r\n`
    }
    Blockly.Python.AI_startBDVoiceRecognize = function (a) {
        let time = Blockly.Python.valueToCode(a, "TIME", 2);
        return `  rcu.startBDVoiceRecognize(${time})\r\n`
    }
    Blockly.Python.AI_SetCameraShow = function (a) {
        let model = a.getFieldValue("MODEL");
        return `  rcu.SetCameraShow(${model})\r\n`
    }







    //显示

    Blockly.Python.E7_getIsTouch = function (a) {
        return ["rcu.getIsTouch()", 1];
    };
    Blockly.Python.E7_GetTouchScreenXY = function (a) {
        let model = a.getFieldValue("MODEL");
        return [`rcu.GetTouchScreenXY("${model}")`, 1];
    };

    Blockly.Python.E7_LCDClearScreen = function (a) {
        let color = a.getFieldValue("COLOR");
        color = Blockly.Python.replaceColor(color)
        return "  rcu.SetLCDClear(" + color + ")\r\n";
    };
    Blockly.Python.E7_SetFontSize = function (a) {
        let fontsize = a.getFieldValue("FONTSIZE");
        return "  rcu.SetFontSize(" + fontsize + ")\r\n";
    };
    Blockly.Python.E7_setColor = function (a) {
        let lines = Blockly.Python.valueToCode(a, "LINES", 2);
        let text = Blockly.Python.valueToCode(a, "TEXT", 99);
        if (text.search(/^\s{0,}$/ig) == 0) {
            text = '"' + text + '"'
        }
        text = a.getInputTargetBlock("TEXT") ? a.getInputTargetBlock("TEXT").isShadow_ ? text : "str(" + text + ")" : ""

        return "  rcu.SetDisplayString(" + lines + "," + text + ")\r\n";
    };
    Blockly.Python.E7_drawImage = function (a) {
        let x = Blockly.Python.valueToCode(a, "IMAGEX", 2);
        let y = Blockly.Python.valueToCode(a, "IMAGEY", 2);
        let filename = Blockly.Python.valueToCode(a, "IMAGEFILENAME", 2);
        let scale = Blockly.Python.valueToCode(a, "IMAGESCALE", 2);
        return "  rcu.SetDisplayPicture(" + x + "," + y + "," + filename + "," + scale + ")\r\n";
    };
    Blockly.Python.E7_diplayData = function (a) {
        let x = Blockly.Python.valueToCode(a, "X", 2);
        let y = Blockly.Python.valueToCode(a, "Y", 2);
        let data = Blockly.Python.valueToCode(a, "DATA", 2);
        let color = a.getFieldValue("COLOR");
        let backgroundcolor = a.getFieldValue("BACKGROUNDCOLOR");
        return "  rcu.SetDisplayVarXY(" + x + "," + y + "," + data + "," + color + "," + backgroundcolor + ")\r\n";
    };
    Blockly.Python.E7_displayCharacter = function (a) {
        let x = Blockly.Python.valueToCode(a, "X", 2);
        let y = Blockly.Python.valueToCode(a, "Y", 2);

        let text = Blockly.Python.valueToCode(a, "CHARACTER", 99);
        text = a.getInputTargetBlock("CHARACTER") ? a.getInputTargetBlock("CHARACTER").isShadow_ ? text : "str(" + text + ")" : ""

        let color = a.getFieldValue("COLOR");
        let backgroundcolor = a.getFieldValue("BACKGROUNDCOLOR");
        let transparent = a.getFieldValue("TRANSPARENT");
        return "  rcu.SetDisplayStringXY(" + x + "," + y + "," + text + "," + color + "," + backgroundcolor + "," + transparent + ")\r\n";
    };
    Blockly.Python.E7_drawPoint = function (a) {
        let x = Blockly.Python.valueToCode(a, "POINTX", 2);
        let y = Blockly.Python.valueToCode(a, "POINTY", 2);
        let color = a.getFieldValue("POINTCOLOR");
        color = Blockly.Python.replaceColor(color)
        return "  rcu.SetLCDDot(" + x + "," + y + "," + color + ")\r\n";
    };
    Blockly.Python.E7_drawLine = function (a) {
        let x = Blockly.Python.valueToCode(a, "LINEX", 2);
        let y = Blockly.Python.valueToCode(a, "LINEY", 2);
        let lineangle = Blockly.Python.valueToCode(a, "LINEANGLE", 2);
        let linelength = Blockly.Python.valueToCode(a, "LINELENGTH", 2);
        let color = a.getFieldValue("LINECOLOR");
        color = Blockly.Python.replaceColor(color)
        return "  rcu.SetLCDLine(" + x + "," + y + "," + lineangle + "," + linelength + "," + color + ")\r\n";
    };
    Blockly.Python.E7_drawCircle = function (a) {
        let x = Blockly.Python.valueToCode(a, "CIRCLEX", 2);
        let y = Blockly.Python.valueToCode(a, "CIRCLEY", 2);
        let circleradius = Blockly.Python.valueToCode(a, "CIRCLERADIUS", 2);
        let color = a.getFieldValue("CIRCLECOLOR");
        color = Blockly.Python.replaceColor(color)
        return "  rcu.SetLCDSolidCircle(" + x + "," + y + "," + circleradius + "," + color + ")\r\n";
    };
    Blockly.Python.E7_drawRectangle = function (a) {
        let x = Blockly.Python.valueToCode(a, "RECTANGLEX", 2);
        let y = Blockly.Python.valueToCode(a, "RECTANGLEY", 2);
        let rectanglewitdh = Blockly.Python.valueToCode(a, "RECTANGLEWIDTH", 2);
        let rectangleheight = Blockly.Python.valueToCode(a, "RECTANGLEHEIGHT", 2);
        let rectanglelinewidth = Blockly.Python.valueToCode(a, "RECTANGLELINEWIDTH", 2);
        let color = a.getFieldValue("RECTANGLECOLOR");
        color = Blockly.Python.replaceColor(color)
        return "  rcu.SetLCDRectangle2(" + x + "," + y + "," + rectanglewitdh + "," + rectangleheight + "," + rectanglelinewidth + "," + color + ")\r\n";
    };
    Blockly.Python.E7_drawSolidRectangle = function (a) {
        let x = Blockly.Python.valueToCode(a, "SOLIDRECTANGLEX", 2);
        let y = Blockly.Python.valueToCode(a, "SOLIDRECTANGLEY", 2);
        let solidrectanglewidth = Blockly.Python.valueToCode(a, "SOLIDRECTANGLEWIDTH", 2);
        let solidrectangleheight = Blockly.Python.valueToCode(a, "SOLIDRECTANGLEHEIGHT", 2);
        let color = a.getFieldValue("SOLIDRECTANGLECOLOR");
        color = Blockly.Python.replaceColor(color)
        return "  rcu.SetLCDFilledRectangle2(" + x + "," + y + "," + solidrectanglewidth + "," + solidrectangleheight + "," + color + ")\r\n";
    };


    Blockly.Python.E7_setPaintColor = function (a) {
        let color = a.getFieldValue("COLOR");
        color = Blockly.Python.replaceColor(color)
        return `  rcu.setPaintColor(${color})\r\n`;
    };
    Blockly.Python.E7_setDisplayStringXYS = function (a) {
        let x = Blockly.Python.valueToCode(a, "X", 16);
        let y = Blockly.Python.valueToCode(a, "Y", 16);
        let text = Blockly.Python.valueToCode(a, "TEXT", 16);
        return `  rcu.setDisplayStringXYS(${x},${y},${text})\r\n`;
    };
    Blockly.Python.E7_setAlpha = function (a) {
        let data = Blockly.Python.valueToCode(a, "DATA", 16);
        return `  rcu.setAlpha(${data})\r\n`;
    };
    Blockly.Python.E7_setZxing = function (a) {
        let data = Blockly.Python.valueToCode(a, "DATA", 16);
        return "  rcu.setZxing(" + data + ");\r\n"
    }



    //播放


    Blockly.Python.play_startMp3ByPai = function (a) {
        let note = a.getFieldValue("NOTE");
        let value = Blockly.Python.valueToCode(a, "VALUE", 16) || 0;
        return `  rcu.startMp3ByPai("${note}",${value})\r\n`;
    };
    Blockly.Python.play_startMp3ByPath = function (a) {
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);
        return `  rcu.startMp3ByPath(${value})\r\n`;
    };
    Blockly.Python.play_waitMp3ByPath = function (a) {
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);
        return `  rcu.waitMp3ByPath(${value})\r\n`;
    };


    Blockly.Python.E7_pausePlayback = function (a) {
        return "  rcu.SetMp3Suspend()\r\n";
    };

    Blockly.Python.E7_playVoiceByName = function (a) {
        let model = a.getFieldValue("MODEL");
        return `  rcu.playVoiceByName(${model})\r\n`;
    };
    Blockly.Python.E7_startRecord = function (a) {
        let time = Blockly.Python.valueToCode(a, "TIME", 16);
        return `  rcu.startRecord(${time})\r\n`;
    };
    Blockly.Python.E7_playRecord = function (a) {
        return `  rcu.playRecord()\r\n`;
    };
    Blockly.Python.E7_addVoiceSpeed = function (a) {
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);
        return `  rcu.addVoiceSpeed(${value})\r\n`;
    };
    Blockly.Python.E7_setVoiceSpeed = function (a) {
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);
        return `  rcu.setVoiceSpeed(${value})\r\n`;
    };
    Blockly.Python.E7_getVoiceSpeed = function (a) {
        return ["rcu.getVoiceSpeed()", 1];
    };
    Blockly.Python.E7_addVoiceValue = function (a) {
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);
        return `  rcu.addVoiceValue(${value})\r\n`;
    };
    Blockly.Python.E7_setVoiceValue = function (a) {
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);
        return `  rcu.setVoiceValue(${value})\r\n`;
    };
    Blockly.Python.E7_getVoiceValue = function (a) {
        return ["rcu.getVoiceValue()", 1];
    };
    Blockly.Python.E7_stopAllVoice = function (a) {
        return `  rcu.stopAllVoice()\r\n`;
    };




    //无线
    Blockly.Python.wireless_getRCUBleData = function (a) {
        return ["rcu.GetBluetoothData()", 1];
    };
    Blockly.Python.wireless_RCUSendBluetoothData = function (a) {
        let data = Blockly.Python.valueToCode(a, "DATA", 2);
        return "  rcu.SetBluetoothData(" + data + ")\r\n";
    };
    Blockly.Python.wireless_getComVoice = function (a) {
        let text = Blockly.Python.valueToCode(a, "TEXT", 2);
        return ["rcu.GetComVoice(" + text + ")", 1];
    };
    Blockly.Python.wireless_getBluetoothControl = function (a) {
        return ["rcu.GetBluetoothControl()", 1];
    };
    Blockly.Python.wireless_getBluetoothControlData = function (a) {
        return ["rcu.GetBluetoothControlData()", 1];
    };
    Blockly.Python.wireless_getBluetoothButton = function (a) {
        return ["rcu.GetBTModuleRemoteButton()", 1];
    };
    Blockly.Python.wireless_getBluetoothCode = function (a) {
        return ["rcu.GetBTModuleRemoteCode()", 1];
    };
    Blockly.Python.wireless_getBluetoothRocker = function (a) {
        let direction = a.getFieldValue("DIRECTION");
        let axis = a.getFieldValue("AXIS");
        return ["rcu.GetBTModuleRemoteRocker(" + direction + "," + axis + ")", 1];
    };

    // pid

    Blockly.Python.pid_setPidControler = function (a) {
        let pid = a.getFieldValue("PID");
        var pidName = a.workspace.getVariableById(pid) ? a.workspace.getVariableById(pid).name : 'null';

        let target = Blockly.Python.valueToCode(a, "TARGET", 2);
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);

        Blockly.Python.pidList.add(`PID_${pidName}`)
        Blockly.Python.pidList.add(`PID_${pidName}_Setpoint`)
        Blockly.Python.pidList.add(`PID_${pidName}_Input`)

        return `  PID_${pidName}_Setpoint = ${target}\r\n` +
            `  PID_${pidName}_Input = ${value}\r\n`;
    };
    Blockly.Python.pid_setPidControlerFork = function (a) {
        Blockly.Python.definitions_.Time = "import time";

        let pid = a.getFieldValue("PID");
        var pidName = a.workspace.getVariableById(pid) ? a.workspace.getVariableById(pid).name : 'null';

        let kp = Blockly.Python.valueToCode(a, "KP", 2);
        let ki = Blockly.Python.valueToCode(a, "KI", 2);
        let kd = Blockly.Python.valueToCode(a, "KD", 2);

        Blockly.Python.pidList.add(`PID_${pidName}`)
        Blockly.Python.pidList.add(`PID_${pidName}_SampleTimeInSec`)
        Blockly.Python.pidList.add(`PID_${pidName}_Kp`)
        Blockly.Python.pidList.add(`PID_${pidName}_Ki`)
        Blockly.Python.pidList.add(`PID_${pidName}_Kd`)
        Blockly.Python.pidList.add(`PID_${pidName}_lastTime`)

        return `  PID_${pidName}_SampleTimeInSec = 0.1\r\n` +
            `  PID_${pidName}_Kp = ${kp}\r\n` +
            `  PID_${pidName}_Ki = ${ki} * PID_${pidName}_SampleTimeInSec\r\n` +
            `  PID_${pidName}_Kd = ${kd} / PID_${pidName}_SampleTimeInSec\r\n` +
            `  PID_${pidName}_lastTime = int(round(time.time() * 1000)) - 100\r\n`;
    };
    Blockly.Python.pid_getPidControlResult = function (a) {
        Blockly.Python.definitions_.Time = "import time";

        let pid = a.getFieldValue("PID");
        var pidName = a.workspace.getVariableById(pid) ? a.workspace.getVariableById(pid).name : 'null';

        Blockly.Python.jmdstart[pid] = `PID_${pidName}_thread`;
        Blockly.Python.pidList.add(`PID_${pidName}`)
        Blockly.Python.pidList.add(`PID_${pidName}_Kp`)
        Blockly.Python.pidList.add(`PID_${pidName}_Ki`)
        Blockly.Python.pidList.add(`PID_${pidName}_Kd`)
        Blockly.Python.pidList.add(`PID_${pidName}_Setpoint`)
        Blockly.Python.pidList.add(`PID_${pidName}_Input`)
        Blockly.Python.pidList.add(`PID_${pidName}_lastErr`)
        Blockly.Python.pidList.add(`PID_${pidName}_lastTime`)

        let pidGlobal = Blockly.Python.getPidGlobal();
        !Blockly.Python.pidThreadFn[pid] ? Blockly.Python.pidThreadFn[pid] = `def PID_${pidName}_thread():
  ${pidGlobal}
  errSum = 0
  while(True):
    now = int(round(time.time() * 1000))
    timeChange = now - PID_${pidName}_lastTime
    if(timeChange >= 100):
        error = PID_${pidName}_Setpoint - PID_${pidName}_Input
        errSum += error
        dErr = error - PID_${pidName}_lastErr
        #PID输出
        PID_${pidName} += PID_${pidName}_Kp * error + PID_${pidName}_Ki * errSum + PID_${pidName}_Kd * dErr

        PID_${pidName}_lastErr = error
        PID_${pidName}_lastTime = now
` : null

        return [`PID_${pidName}`, 1];
    };

    // 运动(E7)
    Blockly.Python.hrcu_motion_setStartMotorLorR = function (a) {
        let port = a.getFieldValue("PORT");
        let porttwo = a.getFieldValue("PORT_TWO");
        return `  rcu.setStartMotorLorR(${port},${porttwo})\r\n`;
    };
    Blockly.Python.hrcu_motion_setMotorByPercent = function (a) {
        let leftValue = Blockly.Python.valueToCode(a, "LEFTVALUE", 16);
        let rightValue = Blockly.Python.valueToCode(a, "RIGHTVALUE", 16);
        return `  rcu.setMotorByPercent(${leftValue},${rightValue})\r\n`;
    };
    Blockly.Python.hrcu_motion_waitMotorByPercent = function (a) {
        let leftValue = Blockly.Python.valueToCode(a, "LEFTVALUE", 16);
        let rightValue = Blockly.Python.valueToCode(a, "RIGHTVALUE", 16);
        let num = Blockly.Python.valueToCode(a, "NUM", 16);
        return `  rcu.waitMotorByPercent(${leftValue},${rightValue},${num})\r\n`;
    };

    Blockly.Python.hrcu_motion_setMotorsByTime = function (a) {
        let speed = Blockly.Python.valueToCode(a, "SPEED", 16);
        let time = Blockly.Python.valueToCode(a, "TIME", 16);
        return `  rcu.setMotorsByTime(${speed},${time})\r\n`;
    };
    Blockly.Python.hrcu_motion_setMotors = function (a) {
        let speed = Blockly.Python.valueToCode(a, "SPEED", 16);
        return `  rcu.setMotors(${speed})\r\n`;
    };
    Blockly.Python.hrcu_motion_setMotorsByLength = function (a) {
        let speed = Blockly.Python.valueToCode(a, "SPEED", 16);
        let length = Blockly.Python.valueToCode(a, "LENGTH", 16);
        return `  rcu.setMotorsByLength(${speed},${length})\r\n`;
    };
    Blockly.Python.hrcu_motion_setMotorsAngle = function (a) {
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let model = a.getFieldValue("MODEL");
        let time = Blockly.Python.valueToCode(a, "TIME", 16);
        return `  rcu.setMotorsAngle(${angle}, "${model}", ${time})\r\n`;
    };
    Blockly.Python.hrcu_motion_stopMotorRun = function (a) {
        return `  rcu.stopMotorRun()\r\n`;
    };
    Blockly.Python.hrcu_motion_setOneCircleSize = function (a) {
        let langth = Blockly.Python.valueToCode(a, "LENGTH", 16);
        return `  rcu.setOneCircleSize(${langth})\r\n`;
    };



    Blockly.Python.control_RunPython = function (a, b, c) {
        let command = Blockly.Python.valueToCode(a, "COMMAND", 2);
        command = command.replace(/^[\"\']/ig, "").replace(/[\"\']$/ig, "")
        if (command !== "") {
            command = `  ${command}\r\n`
        }
        return `${command}`;
    };




    // 扩展： 传感器
    Blockly.Python.extSensor_setAttitude = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("SETATTITUDEMODE");
        return "  rcu.SetAHRS(" + arg1 + "," + arg2 + ")\r\n";
    };
    Blockly.Python.extSensor_getAttitude = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("ATTITUDEMODE");
        return ["rcu.GetAHRS(" + arg1 + "," + arg2 + ",0)", 1];
    };

    Blockly.Python.extSensor_LaserDist = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("LASERDISTMODE");
        return ["rcu.GetLaserDist(" + arg1 + "," + arg2 + ")", 1];
    };
    Blockly.Python.extSensor_ShortIRDist = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["rcu.GetShortIRDist(" + arg1 + ")", 1];
    };
    Blockly.Python.extSensor_Gesture = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["rcu.GetGesture(" + arg1 + ")", 1];
    };
    Blockly.Python.extSensor_sensor_getAirPressure = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["rcu.GetAirPressure(" + arg1 + ")", 1];
    };
    Blockly.Python.extSensor_sensor_getSht30 = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("COMMAND");
        return ["rcu.GetSht30(" + arg1 + "," + arg2 + ")", 1];
    };
    Blockly.Python.extSensor_sensor_getMagnetic = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("MODEL");
        return ["rcu.GetMagnetic(" + arg1 + "," + arg2 + ")", 1];
    };
    Blockly.Python.extSensor_sensor_getScanCamera = function (a) {
        return ["rcu.GetScanCamera()", 1];
    };
    Blockly.Python.extSensor_sensor_getComStrCompare = function (a) {
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);
        return [`rcu.GetComStrCompare(${value})`, 1];
    };
    Blockly.Python.extSensor_smartEyeDist = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["rcu.GetSmartEyeDist(" + arg1 + ")", 1];
    };
    Blockly.Python.extSensor_smartEyeIRCode = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["rcu.GetSmartEyeIRcode(" + arg1 + ")", 1];
    };
    Blockly.Python.extSensor_setSmartEyeIRCode = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.Python.valueToCode(a, "VALUE", 2);
        return "  rcu.SetSmartEyeIRcode(" + arg1 + "," + arg2 + ")\r\n";
    };
    Blockly.Python.extSensor_setSmartEye = function (a) {

        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("SMARTEYEMODE");

        let arg3 = Blockly.Python.valueToCode(a, "COLOR", 2);
        arg3 = Blockly.Python.transformColor(arg3) //转换成 0x的形式

        return "  rcu.SetSmartEyeMode(" + arg1 + "," + arg2 + "," + arg3 + ")\r\n";
    };
    Blockly.Python.extSensor_setSmartEyeAllLed = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");

        let arg2 = Blockly.Python.valueToCode(a, "COLOR1", 2);
        arg2 = Blockly.Python.transformColor(arg2) //转换成 0x的形式

        let arg3 = Blockly.Python.valueToCode(a, "COLOR2", 2);
        arg3 = Blockly.Python.transformColor(arg3) //转换成 0x的形式

        let arg4 = Blockly.Python.valueToCode(a, "COLOR3", 2);
        arg4 = Blockly.Python.transformColor(arg4) //转换成 0x的形式

        let arg5 = Blockly.Python.valueToCode(a, "COLOR4", 2);
        arg5 = Blockly.Python.transformColor(arg5) //转换成 0x的形式

        let arg6 = Blockly.Python.valueToCode(a, "COLOR5", 2);
        arg6 = Blockly.Python.transformColor(arg6) //转换成 0x的形式

        let arg7 = Blockly.Python.valueToCode(a, "COLOR6", 2);
        arg7 = Blockly.Python.transformColor(arg7) //转换成 0x的形式

        let arg8 = Blockly.Python.valueToCode(a, "COLOR7", 2);
        arg8 = Blockly.Python.transformColor(arg8) //转换成 0x的形式

        let arg9 = Blockly.Python.valueToCode(a, "COLOR8", 2);
        arg9 = Blockly.Python.transformColor(arg9) //转换成 0x的形式

        return "  rcu.SetSmartEyeAllLed(" + arg1 + "," + arg2 + "," + arg3 + "," + arg4 + "," + arg5 + "," + arg6 + "," + arg7 + "," + arg8 + "," + arg9 + ")\r\n";
    };
    Blockly.Python.extSensor_SetDisplayLatticeClear = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        return "  rcu.SetDisplayLatticeClear(" + arg1 + ")\r\n";
    };
    Blockly.Python.extSensor_SetDisplayLatticePic = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");

        let arg2 = Blockly.Python.valueToCode(a, "MATRIX", 2);
        arg2 = '"' + Blockly.Python.matrixToString16(arg2) + '"'

        let arg3 = a.getFieldValue("LIGHTNESS");

        return "  rcu.SetDisplayLatticePic(" + arg1 + "," + arg2 + "," + arg3 + ")\r\n";
    };
    Blockly.Python.extSensor_SetDisplayLattice = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");

        let arg2 = Blockly.Python.valueToCode(a, "VALUE", 99);
        arg2 = a.getInputTargetBlock("VALUE") ? a.getInputTargetBlock("VALUE").isShadow_ ? arg2 : "str(" + arg2 + ")" : ""

        let arg3 = a.getFieldValue("LIGHTNESS");
        return "  rcu.SetDisplayLattice(" + arg1 + "," + arg2 + "," + arg3 + ")\r\n";
    };
    Blockly.Python.extSensor_SetDisplayLatticeXY = function (a) {

        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.Python.valueToCode(a, "X", 2);
        let arg3 = Blockly.Python.valueToCode(a, "Y", 2);
        let arg4 = a.getFieldValue("STATES");
        let arg5 = a.getFieldValue("LIGHTNESS");

        return "  rcu.SetDisplayLatticeXY(" + arg1 + "," + arg2 + "," + arg3 + "," + arg4 + "," + arg5 + ")\r\n";
    };
    Blockly.Python.extSensor_SetDisplayLatticeString = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");

        let arg2 = Blockly.Python.valueToCode(a, "STRING", 99);
        arg2 = a.getInputTargetBlock("STRING") ? a.getInputTargetBlock("STRING").isShadow_ ? arg2 : "str(" + arg2 + ")" : ""

        let arg3 = a.getFieldValue("DIRECTION");
        let arg4 = Blockly.Python.valueToCode(a, "SPEED", 2);
        let arg5 = a.getFieldValue("LIGHTNESS");

        return "  rcu.SetDisplayLatticeString(" + arg1 + "," + arg2 + "," + arg3 + "," + arg4 + "," + arg5 + ")\r\n";
    };


    // 扩展： AI

    Blockly.Python.AI_sensor_setWaitForAICamData = function (a) {
        let arg1 = a.getFieldValue("DATA");
        return "  rcu.SetWaitForAICamData(" + arg1 + ",0)\r\n";
    };
    Blockly.Python.AI_sensor_setAICamData = function (a) {
        let arg1 = a.getFieldValue("DATA");
        return "  rcu.SetAICamData(" + arg1 + ",0)\r\n";
    };
    Blockly.Python.AI_sensor_setAICamLED = function (a) {
        let status = a.getFieldValue("LEDSTATUS");
        return "  rcu.SetAICamLED(" + status + ")\r\n";
    };
    Blockly.Python.AI_sensor_getAICamDataColorDetect = function (a) {
        let arg1 = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataQR = function (a) {
        let arg1 = a.getFieldValue("COLOR6");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataBall = function (a) {
        let arg1 = a.getFieldValue("COLOR2");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataRoad = function (a) {
        let arg1 = a.getFieldValue("COLOR5");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataFaceDetect = function (a) {
        let arg1 = a.getFieldValue("COLOR3");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataImage = function (a) {
        let arg1 = a.getFieldValue("COLOR7");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataApriltag = function (a) {
        let arg1 = a.getFieldValue("COLOR7");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataGesture = function (a) {
        let arg1 = a.getFieldValue("COLOR7");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataTraffic = function (a) {
        let arg1 = a.getFieldValue("COLOR7");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataColorLearning = function (a) {
        let arg1 = a.getFieldValue("COLOR1");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataFaceLearning = function (a) {
        let arg1 = a.getFieldValue("COLOR4");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataImageStudy = function (a) {
        let arg1 = a.getFieldValue("COLOR7");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamData = function (a) {
        let arg1 = a.getFieldValue("DATA1");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamVoice = function (a) {
        let arg1 = a.getFieldValue("ORDER");
        return ["rcu.GetAICamVoice(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_setFaceRegister = function (a) {
        let arg1 = Blockly.Python.valueToCode(a, "ID", 2);
        return "  rcu.SetFaceRegister(" + arg1 + ")\r\n"
    };
    Blockly.Python.AI_sensor_getFaceRegisterData = function (a) {
        let arg1 = Blockly.Python.valueToCode(a, "ID", 2);
        return ["rcu.GetFaceRegisterData(" + arg1 + ")", 1];
    };

    // hrcu_iot 通讯


    Blockly.Python.hrcu_iot_initIot = function (a) {
        return `  rcu.initIot()\r\n`
    };
    Blockly.Python.hrcu_iot_isIotDeviceData = function (a) {
        let iotlist = a.getFieldValue("IOTLIST");
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);
        return [`rcu.isIotDeviceData("${iotlist}", ${value})`, 1];
    };
    Blockly.Python.hrcu_iot_getIotDeviceData = function (a) {
        let iotlist = a.getFieldValue("IOTLIST");
        return [`rcu.getIotDeviceData("${iotlist}")`, 1];
    };
    Blockly.Python.hrcu_iot_setIotDeviceData = function (a) {
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);
        let iotlist = a.getFieldValue("IOTLIST");
        return `  rcu.setIotDeviceData(${value}, "${iotlist}")\r\n`
    };

    Blockly.Python.hrcu_iot_isIotInit = function (a) {
        return [`rcu.isIotInit()`, 1];
    };
    Blockly.Python.hrcu_iot_setWifiData = function (a) {
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);
        return `  rcu.setWifiData(${value})\r\n`
    };
    Blockly.Python.hrcu_iot_getWifiData = function (a) {
        return [`rcu.getWifiData()`, 1];
    };
    Blockly.Python.hrcu_iot_resetIotResult = function (a) {
        return `  rcu.resetIotResult()\r\n`
    };
    Blockly.Python.hrcu_iot_startWebService = function (a) {
        return `  rcu.startWebService()\r\n`
    };

    Blockly.Python.hrcu_iot_getWebUrl = function (a) {
        return [`rcu.getWebUrl()`, 1];
    };

    Blockly.Python.hrcu_iot_getWebData = function (a) {
        let account_type = a.getFieldValue("ACCOUNTTYPE");
        return [`rcu.getWebData("${account_type}")`, 1];
    };

    Blockly.Python.hrcu_iot_setRcuBluetoothData = function (a) {
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);
        return `  rcu.setRcuBluetoothData("${value}")\r\n`
    };
    Blockly.Python.hrcu_iot_getRcuBluetoothData = function (a) {
        return [`rcu.getRcuBluetoothData()`, 1];
    };
    Blockly.Python.hrcu_communication_GetPhoneWiFiYGData = function (a) {
        let direction = a.getFieldValue("DIRECTION");
        let mode = a.getFieldValue("MODE");
        return [`rcu.GetPhoneWiFiYGData("${direction}", "${mode}")`, 1];
    };
    Blockly.Python.hrcu_communication_IsPhoneWiFiBtnData = function (a) {
        let mode = a.getFieldValue("MODE");
        return [`rcu.IsPhoneWiFiBtnData("${mode}")`, 1];
    };
    Blockly.Python.hrcu_communication_IsPhoneWiFiYGData = function (a) {
        let direction = a.getFieldValue("DIRECTION");
        let mode = a.getFieldValue("MODE");
        return [`rcu.IsPhoneWiFiYGData("${direction}", "${mode}")`, 1];
    };
    Blockly.Python.hrcu_communication_OpenCameraForPhone = function (a) {
        let mode = a.getFieldValue("MODE");
        return `  rcu.OpenCameraForPhone("${mode}")\r\n`
    };
    Blockly.Python.hrcu_communication_SendWifiBtnDescribe = function (a) {
        let btn = a.getFieldValue("BTN");
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);
        return `  rcu.SendWifiBtnDescribe("${btn}",${value})\r\n`
    };


    // 无线扩展

    Blockly.Python.extWireless_setRFPassWord = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.Python.valueToCode(a, "DATA", 2);
        return `  rcu.SetRFPassWord(${arg1}, ${arg2})\r\n`;
    };
    Blockly.Python.extWireless_setRFModuleByte = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.Python.valueToCode(a, "DATA", 2);
        return `  rcu.SetRFModuleByte(${arg1}, ${arg2})\r\n`;
    };
    Blockly.Python.extWireless_getRFModuleByte = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        return [`rcu.GetRFModuleByte(${arg1})`, 1];
    };
    Blockly.Python.extWireless_getRFModuleRemoteButton = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        return [`rcu.GetRFModuleRemoteButton(${arg1})`, 1];
    };
    Blockly.Python.extWireless_getRFModuleRemoteCode = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        return [`rcu.GetRFModuleRemoteCode(${arg1})`, 1];
    };
    Blockly.Python.extWireless_getRFModuleRemoteGravity = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("AXIS");
        return [`rcu.GetRFModuleRemoteGravity(${arg1}, ${arg2})`, 1];
    };
    Blockly.Python.extWireless_getRFModuleRemoteRocker = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("DIRECTION");
        let arg3 = a.getFieldValue("AXIS");
        return [`rcu.GetRFModuleRemoteRocker(${arg1}, ${arg2}, ${arg3})`, 1];
    };
    Blockly.Python.extWireless_getRFModuleRemoteBit = function (a) {
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("BTN");
        return [`rcu.GetRFModuleRemoteBit(${arg1}, ${arg2})`, 1];
    };


    // 扩展 魔方

    Blockly.Python.MF_StartCamera = function (a) {
        let status = a.getFieldValue("STATUS2");
        return `  rcu.startCamera("${status}","魔方颜色识别")\r\n`
    }

    Blockly.Python.MF_isMfConnect = function (a) {
        return [`rcu.isMfConnect()`, 1];
    };
    Blockly.Python.MF_runNext = function (a) {
        return [`rcu.runNext()`, 1];
    };
    Blockly.Python.MF_startMFColor = function (a) {
        let num = a.getFieldValue("NUM");
        return [`rcu.startMFColor(${num})`, 1];
    };

    // 扩展 龙舟
    Blockly.Python.DragonBoat_GetSimplePoseList = function (a) {
        let part = a.getFieldValue("PART");
        let coordinate = a.getFieldValue("COORDINATE");
        return [`rcu.getSimplePoseList("${part}","${coordinate}")`, 1];
    };
    Blockly.Python.DragonBoat_GetShipSpeed = function (a) {
        return [`rcu.getShipSpeed()`, 1];
    };

    // 扩展 麦轮
    Blockly.Python.Mecanumwheel_SetMecanumwheel = function (a) {
        let part1 = a.getFieldValue("PART1");
        let part2 = a.getFieldValue("PART2");
        let part3 = a.getFieldValue("PART3");
        let part4 = a.getFieldValue("PART4");
        return `  rcu.SetMecanumwheel(${part1},${part2},${part3},${part4})\r\n`;
    };
    Blockly.Python.Mecanumwheel_SetMecanumSpeed = function (a) {

        let speed1 = Blockly.Python.valueToCode(a, "SPEED1", 2)
        let speed2 = Blockly.Python.valueToCode(a, "SPEED2", 2)
        let speed3 = Blockly.Python.valueToCode(a, "SPEED3", 2)
        let speed4 = Blockly.Python.valueToCode(a, "SPEED4", 2)
        return `  rcu.SetMecanumSpeed(${speed1},${speed2},${speed3},${speed4})\r\n`;
    };
    Blockly.Python.Mecanumwheel_SetMecanumMoveLR = function (a) {

        let speed = Blockly.Python.valueToCode(a, "SPEED", 2)
        let direction = a.getFieldValue("DIRECTION");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2)
        return `  rcu.SetMecanumMoveLR(${speed},${direction},${angle})\r\n`;
    };
    
    Blockly.Python.Mecanumwheel_SetCarSpeed = function (a) {

        let speed = Blockly.Python.valueToCode(a, "SPEED", 2)
        return `  rcu.setCarSpeed(${speed})\r\n`;
    };
    Blockly.Python.Mecanumwheel_SetCarStop = function (a) {

        return `  rcu.SetCarStop()\r\n`;
    };
    Blockly.Python.Mecanumwheel_SetCarToAngleTime = function (a) {

        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2)
        let secound = Blockly.Python.valueToCode(a, "SECOUND", 2)
        return `  rcu.SetCarToAngleTime(${angle}, ${secound})\r\n`;
    };
    Blockly.Python.Mecanumwheel_SetCarToAngle = function (a) {

        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2)
        return `  rcu.SetCarToAngle(${angle})\r\n`;
    };
    Blockly.Python.Mecanumwheel_SetCarToRLTime = function (a) {

        let direction = a.getFieldValue("DIRECTION");
        let secound = Blockly.Python.valueToCode(a, "SECOUND", 2)
        return `  rcu.SetCarToRLTime(${direction}, ${secound})\r\n`;
    };
    Blockly.Python.Mecanumwheel_SetCarToRL = function (a) {

        let direction = a.getFieldValue("DIRECTION");
        return `  rcu.SetCarToRL(${direction})\r\n`;
    };





    //   列表
    Blockly.Python.data_listHead = "LIST_"
    Blockly.Python.data_listcontents = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';

        listname = Blockly.Python.data_listHead + listname

        return [listname, 1]
    };
    Blockly.Python.data_addtolist = function (a) {
        let str = Blockly.Python.valueToCode(a, "ITEM", 2)

        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        return `  ${listname}.append(${str})\r\n`
    };
    Blockly.Python.data_setlist = function (a) {
        let value = Blockly.Python.valueToCode(a, "VALUE", 2)

        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        return `  ${listname} = str(${value}).split(',')\r\n`
    };

    Blockly.Python.data_deleteoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        let line = Blockly.Python.valueToCode(a, "INDEX", 2)

        if (isNaN(Number(line))) {
            let str = line.replace(/\(|\)/ig, "")
            if (isNaN(Number(str))) {
                line = line + " - 1"
            } else {
                line = Number(line) > 0 ? Number(line) - 1 : 0;
            }
        } else {
            line = Number(line) > 0 ? Number(line) - 1 : 0;
        }
        return `  del ${listname}[${line}]\r\n`
    };

    Blockly.Python.data_deletealloflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname
        return `  del ${listname}[:]\r\n`
    };

    Blockly.Python.data_insertatlist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        let index = Blockly.Python.valueToCode(a, "INDEX", 2)
        if (isNaN(Number(index))) {
            let str = index.replace(/\(|\)/ig, "")
            if (isNaN(Number(str))) {
                index = index + " - 1"
            } else {
                index = Number(index) > 0 ? Number(index) - 1 : 0;
            }
        } else {
            index = Number(index) > 0 ? Number(index) - 1 : 0;
        }

        let item = Blockly.Python.valueToCode(a, "ITEM", 2)
        return `  ${listname}.insert(${index}, ${item})\r\n`
    };
    Blockly.Python.data_replaceitemoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        let index = Blockly.Python.valueToCode(a, "INDEX", 2)
        console.log(index)
        if (isNaN(Number(index))) {
            let str = index.replace(/\(|\)/ig, "")
            if (isNaN(Number(str))) {
                index = index + " - 1"
            } else {
                index = Number(index) > 0 ? Number(index) - 1 : 0;
            }
        } else {
            index = Number(index) > 0 ? Number(index) - 1 : 0;
        }


        let item = Blockly.Python.valueToCode(a, "ITEM", 2)
        return `  ${listname}[${index}] = ${item}\r\n`
    };

    Blockly.Python.data_listcontainsitem = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        let str = Blockly.Python.valueToCode(a, "ITEM", 2)
        return [`${str} in ${listname}`, 2]
    };

    Blockly.Python.data_itemnumoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        let str = Blockly.Python.valueToCode(a, "ITEM", 2)
        return [`${listname}.index(${str})`, 1]
    };

    Blockly.Python.data_itemoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        let num = Blockly.Python.valueToCode(a, "INDEX", 2)

        if (isNaN(Number(num))) {
            let str = num.replace(/\(|\)/ig, "")
            if (isNaN(Number(str))) {
                num = num + " - 1"
            } else {
                num = Number(num) > 0 ? Number(num) - 1 : 0;
            }
        } else {
            num = Number(num) > 0 ? Number(num) - 1 : 0;
        }
        return [`${listname}[${num}]`, 1]
    };
    Blockly.Python.data_lengthoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        return [`len(${listname})`, 1]
    };



    //运算
    Blockly.Python.operator_add = function (a) {
        let NUM1 = Blockly.Python.valueToCode(a, "NUM1", 2) || 1
        let NUM2 = Blockly.Python.valueToCode(a, "NUM2", 2) || 1
        return [`${NUM1} + ${NUM2}`, 2]
    };
    Blockly.Python.operator_subtract = function (a) {
        let NUM1 = Blockly.Python.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.Python.valueToCode(a, "NUM2", 2)
        return [`${NUM1} - ${NUM2}`, 2]
    };
    Blockly.Python.operator_multiply = function (a) {
        let NUM1 = Blockly.Python.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.Python.valueToCode(a, "NUM2", 2)
        return [`${NUM1} * ${NUM2}`, 2]
    };
    Blockly.Python.operator_divide = function (a) {
        let NUM1 = Blockly.Python.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.Python.valueToCode(a, "NUM2", 2)
        return [`${NUM1} / ${NUM2}`, 2]
    };
    Blockly.Python.math_arithmetic = function (a) {
        let RANDOMSTART = Blockly.Python.valueToCode(a, "A", 2)
        let OP = a.getFieldValue("OP")
        let RANDOMEND = Blockly.Python.valueToCode(a, "B", 2)
        return [`${RANDOMSTART} ${OP} ${RANDOMEND}`, 2]
    };
    Blockly.Python.operator_random = function (a) {
        let RANDOMSTART = Blockly.Python.valueToCode(a, "FROM", 2)
        let RANDOMEND = Blockly.Python.valueToCode(a, "TO", 2)
        return [`rcu.GetRandom(${RANDOMSTART},${RANDOMEND})`, 1]
    };
    Blockly.Python.operator_lt = function (a) {
        let OPERAND1 = Blockly.Python.valueToCode(a, "OPERAND1", 2)
        let OPERAND2 = Blockly.Python.valueToCode(a, "OPERAND2", 2)
        return [`${OPERAND1} < ${OPERAND2}`, 2]
    };
    Blockly.Python.operator_equals = function (a) {
        let OPERAND1 = Blockly.Python.valueToCode(a, "OPERAND1", 2)
        let OPERAND2 = Blockly.Python.valueToCode(a, "OPERAND2", 2)
        return [`${OPERAND1} == ${OPERAND2}`, 2]
    };
    Blockly.Python.operator_gt = function (a) {
        let OPERAND1 = Blockly.Python.valueToCode(a, "OPERAND1", 2)
        let OPERAND2 = Blockly.Python.valueToCode(a, "OPERAND2", 2)
        return [`${OPERAND1} > ${OPERAND2}`, 2]
    };
    Blockly.Python.operator_and = function (a) {
        let OPERAND1 = Blockly.Python.valueToCode(a, "OPERAND1", 2) || "()"
        let OPERAND2 = Blockly.Python.valueToCode(a, "OPERAND2", 2) || "()"
        return [`${OPERAND1} and ${OPERAND2}`, 2]
    };
    Blockly.Python.operator_or = function (a) {
        let OPERAND1 = Blockly.Python.valueToCode(a, "OPERAND1", 2) || "()"
        let OPERAND2 = Blockly.Python.valueToCode(a, "OPERAND2", 2) || "()"
        return [`${OPERAND1} or ${OPERAND2}`, 2]
    };
    Blockly.Python.operator_not = function (a) {
        let OPERAND = Blockly.Python.valueToCode(a, "OPERAND", 2)
        return [`not(${OPERAND})`, 2]
    };
    Blockly.Python.operator_mod = function (a) {
        let NUM1 = Blockly.Python.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.Python.valueToCode(a, "NUM2", 2)
        return [`${NUM1} % ${NUM2}`, 2]
    };
    Blockly.Python.operator_round = function (a) {
        let NUM = Blockly.Python.valueToCode(a, "NUM", 2)
        return [`round(${NUM})`, 2]
    };
    Blockly.Python.operator_mathop = function (a) {
        Blockly.Python.definitions_.Math = "import math";
        let OPERATOR = a.getFieldValue("OPERATOR")
        let NUM = Blockly.Python.valueToCode(a, "NUM", 2)
        let str = ''
        if (OPERATOR === "abs") {
            str = `math.fabs(${NUM})`
        } else if (OPERATOR === "e ^") {
            str = `math.pow(math.e,${NUM})`
        } else if (OPERATOR === "10 ^") {
            str = `math.pow(10,${NUM})`
        } else {
            str = `math.${OPERATOR}(${NUM})`
        }
        return [str, 2]
    };

    Blockly.Python.operator_join = function (a) {
        let string1 = Blockly.Python.valueToCode(a, "STRING1", 2)
        let string2 = Blockly.Python.valueToCode(a, "STRING2", 2)
        return [`"".join((str(${string1}),str(${string2})))`, 1]
    };

    Blockly.Python.operator_letter_of = function (a) {
        let letter = Blockly.Python.valueToCode(a, "LETTER", 2)
        let string = Blockly.Python.valueToCode(a, "STRING", 2)

        if (!isNaN(Number(letter))) {
            if (letter <= 0) {
                letter = 0
            } else {
                letter -= 1
            }
        } else {
            letter = 1
        }

        return [`${string}[${letter}]`, 1]
    };

    Blockly.Python.operator_length = function (a) {
        let string = Blockly.Python.valueToCode(a, "STRING", 2)
        return [`len(${string})`, 1]
    };

    Blockly.Python.operator_contains = function (a) {
        let string1 = Blockly.Python.valueToCode(a, "STRING1", 2)
        let string2 = Blockly.Python.valueToCode(a, "STRING2", 2)
        return [`${string2} in ${string1}`, 1]
    };
    Blockly.Python.operator_isStringSame = function (a) {
        let StringOne = Blockly.Python.valueToCode(a, "string_one", 3)
        let StringTwo = Blockly.Python.valueToCode(a, "string_two", 3)
        return [`rcu.isStringSame(${StringOne},${StringTwo})`, 1]
    };
    Blockly.Python.operator_fotmatToFloat = function (a) {
        let str = Blockly.Python.valueToCode(a, "STR", 3)
        return [`rcu.fotmatToFloat(str(${str}))`, 1]
    };
    Blockly.Python.operator_isInclud = function (a) {
        let string1 = Blockly.Python.valueToCode(a, "string_one", 2)
        let string2 = Blockly.Python.valueToCode(a, "string_two", 2)
        return [`str(${string2}) in str(${string1})`, 1]
    };
    Blockly.Python.operator_getStringFormat = function (a) {
        let string1 = Blockly.Python.valueToCode(a, "string_one", 2)
        let string2 = Blockly.Python.valueToCode(a, "string_two", 2)
        return [`rcu.getStringFormat(${string1},${string2})`, 1]
    };

    Blockly.Python.operator_strToNum = function (a) {
        let string = Blockly.Python.valueToCode(a, "STRING", 3) || ""
        return [`rcu.stringToNum(${string})`, 1]
    };
    Blockly.Python.operator_numToStr = function (a) {
        let num = Blockly.Python.valueToCode(a, "NUM", 3) || ""
        return [`rcu.numToString(${num})`, 1]
    };



    //部分模块转换

    Blockly.Python.text = function (a) {
        let textValue = a.getFieldValue("TEXT") || ''
        if (a.getParent().type === "extSensor_SetDisplayLattice" ||
            a.getParent().type === "operator_isInclud") {
            return [`"${textValue}"`, 1]
        } else {
            if (isNaN(textValue * 1)) {
                textValue = '"' + textValue + '"'
                return [textValue, 1]
            } else {
                return [textValue, 1]
            }
        }
    }

    Blockly.Python.textvalue = function (a) {
        let textValue = a.getFieldValue("TEXT") || ''
        return ['"' + textValue + '"', 1]

    }

    Blockly.Python.math_integer = function (a) {
        let value = a.getFieldValue('NUM') || 'null'
        return [value, 1]
    };

    Blockly.Python.math_number = function (a) {
        let value = a.getFieldValue('NUM') || 'null'
        return [value, 1]
    };
    Blockly.Python.math_whole_number = function (a) {
        let value = a.getFieldValue('NUM') || 'null'
        return [value, 1]
    };

    Blockly.Python.jmd_time_menu = function (a) {
        let time = a.getFieldValue('TIME') || 'null'
        return [time, 1]
    };

    Blockly.Python.motor_speed_menu = function (a) {
        let value = a.getFieldValue('VALUE') || 'null'
        return [value, 1]
    };

    Blockly.Python.motor_angle_menu = function (a) {
        let angle = a.getFieldValue('ANGLE') || 'null'
        return [angle, 1]
    };

    Blockly.Python.motor_angle_menu_two = function (a) {
        let angle = a.getFieldValue('ANGLE') || 'null'
        return [angle, 1]
    };

    Blockly.Python.motor_angle_menu_three = function (a) {
        let angle = a.getFieldValue('ANGLE') || 'null'
        return [angle, 1]
    };

    Blockly.Python.motor_angle_menu_four = function (a) {
        let angle = a.getFieldValue('ANGLE') || 'null'
        return [angle, 1]
    };

    Blockly.Python.show_lines_menu = function (a) {
        let lines = a.getFieldValue('LINES') || 'null'
        return [lines, 1]
    };
    Blockly.Python.play_folder_menu = function (a) {
        let foldername = a.getFieldValue('FOLDERNAME') || 'null'
        return [foldername, 1]
    };

    Blockly.Python.play_music_menu = function (a) {
        let musicname = a.getFieldValue('MUSICNAME') || 'null'
        return [musicname, 1]
    };

    Blockly.Python.colour_picker = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };

    Blockly.Python.colour_picker_Red = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };

    Blockly.Python.colour_picker_Orange = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.Python.colour_picker_Yellow = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.Python.colour_picker_Green = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.Python.colour_picker_Blue = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.Python.colour_picker_Indigo = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.Python.colour_picker_Purple = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.Python.colour_picker_White = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };

    Blockly.Python.matrix = function (a) {
        let matrix = a.getFieldValue('MATRIX') || 'null'
        return [matrix, 1]
    };

    Blockly.Python.AI_city_menu = function (a) {
        let value = a.getFieldValue('CITYVALUE') || 'null'
        return ['"' + value + '"', 1]
    }

    Blockly.Python.AI_PostAngelValue = function (a) {
        let value = a.getFieldValue('VALUE') || 'null'
        return [value, 1]
    }
    Blockly.Python.AI_PostAngelValue2 = function (a) {
        let value = a.getFieldValue('VALUE') || 'null'
        return [value, 1]
    }







    // 变量
    Blockly.Python.variables = {};
    Blockly.Python.variablesHead = "VAR_";
    Blockly.Python.data_variable = function (a) {
        let varible = a.workspace.getVariableById(a.getFieldValue("VARIABLE")) ? a.workspace.getVariableById(a.getFieldValue("VARIABLE")).name : ""

        varible = Blockly.Python.variablesHead + varible

        return [varible, Blockly.Python.ORDER_ATOMIC]
    };
    Blockly.Python.data_setvariableto = function (a) {
        let varible = a.workspace.getVariableById(a.getFieldValue("VARIABLE")) ? a.workspace.getVariableById(a.getFieldValue("VARIABLE")).name : ""
        let num = Blockly.Python.valueToCode(a, "VALUE", 2)
        varible = Blockly.Python.variablesHead + varible
        return `  ${varible} = ${num}\r\n`
    };
    Blockly.Python.data_changevariableby = function (a) {
        let varible = a.workspace.getVariableById(a.getFieldValue("VARIABLE")) ? a.workspace.getVariableById(a.getFieldValue("VARIABLE")).name : ""
        let num = Blockly.Python.valueToCode(a, "VALUE", 2)
        varible = Blockly.Python.variablesHead + varible
        return `  ${varible} += ${num}\r\n`
    };




    // 自制积木

    // %s 数字类型控件 argument_reporter_string_number
    // %d 布尔类型控件 argument_reporter_boolean


    Blockly.Python.procedures_definition = function (a) {
        let b = Blockly.Python.blockToCode(a.workspace.getBlockById(a.getChildren(a)[0].id))
        let passEnd = a.getNextBlock() ? "" : "  pass\n"
        return "def " + b + ":[GLOBAL]\r\n" + passEnd;
    };
    Blockly.Python.procedures_prototype = function (a) {
        // console.log('procedures_prototype', a)
        let fnName = a.getProcCode().replace(/%[sbn\s]|\s/ig, '').trim()
        let children = a.getChildren(a)
        let array = []
        for (let i = 0; i < children.length; i++) {
            if (a.workspace.getBlockById(children[i].id)) {
                let value = Blockly.Python.blockToCode(a.workspace.getBlockById(children[i].id))
                array.push(value[0])
            }
        }
        fnName += `(${array.join(',')})`

        return fnName;
    };
    Blockly.Python.argument_reporter_boolean = function (a) {
        // console.log('argument_reporter_boolean', a)
        let text = a.inputList[0].fieldRow[0].getText()
        // console.log(a.inputList[0].fieldRow[0].getText())
        return [text, 1];
    };
    Blockly.Python.argument_reporter_string_number = function (a) {
        // console.log('argument_reporter_string_number', a)
        let text = a.inputList[0].fieldRow[0].getText()
        // console.log(a.inputList[0].fieldRow[0].getText())

        return [text, 1];
    };

    Blockly.Python.procedures_call = function (a) {
        // console.log('procedures_call', a)

        let array = []
        let fnName = a.getProcCode().replace(/(%s|%b|%n)|\s/ig, '')

        for (let i = 0; i < a.inputList.length; i++) {
            if (a.inputList[i].name !== '') {
                let blocks = a.inputList[i].connection.targetBlock()
                if (blocks) {
                    let child = Blockly.Python.blockToCode(a.workspace.getBlockById(blocks.id))
                    if (Array.isArray(child)) {
                        var arg = child[0]
                        if (child[1] === 2 || child[1] === 99) {
                            arg = '(' + arg + ')'
                        }
                        if (!(/[^\s]/ig.test(child[0]))) {
                            array.push('"' + arg + '"')
                        } else {
                            array.push(arg)
                        }
                    } else {
                        array.push(child)
                    }
                } else {
                    array.push('False')
                }
            }
        }

        fnName += `(${array.join(',')})`

        return `  ${fnName}\r\n`;
    };


}

export {
    toPython_E7
}
